// ═══════════════════════════════════════════════
//   KONMAIL v3, Calendar-locked story arc (May 18–28 2026, Dokomi May 29)
//   Loaded after data.js, before state.js. Exports:
//     window.KONMAIL_STORY        : 40 emails + 1 conditional + 1 Day-11 stub
//     window.KONMAIL_ENDINGS      : 5 endings (Good / Warm Strange / Unsettled / Documented / Bad)
//     window.KONMAIL_STORY_DAYS   : { 1:'2026-05-18', ..., 11:'2026-05-28' }
//     window.KONMAIL_STORY_START  : '2026-05-18' (Day 1)
//     window.KONMAIL_STORY_END    : '2026-05-28' (Day 11)
//
//   Per-email shape:
//     id, day (1-11), from, email, subject, portraitEmoji, portraitColor, body,
//     unlock: { type:'date', day:N, requires?:{...} },
//     requiresReply?: bool   (used by penalty engine on missed days)
//     missedPenalty?: { shopHealth?, recordsKept?, ... } (applied when day passes 'pending')
//     expiresOnDay?: N       (auto-expire at end of day N, e.g. Cassian Day 5 hold)
//     silenceFrom?: 'hideo'|'petra'|'goro'|'barnabe'|'bianca'|'clow'|'inspector'|'pemba'
//     variants?: [{ when:{...}, body, choices? }]  (first match wins, default body otherwise)
//     choices: [{ label, effects:{ shopHealth?, clowAwareness?, mysteryDepth?, recordsKept?,
//                                  trustHideo?, trustPetra?, pts? },
//                 followup?: 'same-day reply text', conditionalOn?: {...} }]
//
//   `effects` numeric fields are deltas (+5 / -8). Trust fields are SET to 'low'|'mid'|'high'.
//   `pts` is the in-game points reward (defaults to 5 if not set on a positive-tone choice).
// ═══════════════════════════════════════════════

const KONMAIL_STORY_DAYS = {
    1:  '2026-05-18',  // Mon
    2:  '2026-05-19',  // Tue
    3:  '2026-05-20',  // Wed
    4:  '2026-05-21',  // Thu
    5:  '2026-05-22',  // Fri
    6:  '2026-05-23',  // Sat
    7:  '2026-05-24',  // Sun
    8:  '2026-05-25',  // Mon
    9:  '2026-05-26',  // Tue
    10: '2026-05-27',  // Wed
    11: '2026-05-28',  // Thu, ENDING (Dokomi opens May 29)
};

const KONMAIL_STORY_START = '2026-05-18';
const KONMAIL_STORY_END   = '2026-05-28';

const KONMAIL_STORY = [

    // ════════════════════════════════════════════════
    //   DAY 1 · Mon May 18, Web opens. Story begins.
    // ════════════════════════════════════════════════
    {
        id: 'd01_clow_handover',
        day: 1, unlock: { type:'date', day:1 },
        from: '✦ Clowri',
        email: 'clowri@madriguera.bun',
        subject: "you've got this (and also the keys)",
        portraitEmoji: '✦',
        portraitColor: '#e9d5ff',
        requiresReply: true,
        silenceFrom: 'clow',
        body: `ok hi ✦\n\ni'm in düsseldorf. got in last night, hands still smell like metal from the booth fixtures. the konbini is yours for eleven days. you'll do fine.\n\nmanifests in the back office, on the left shelf. petra knows everything if you get stuck, she comes by mondays and thursdays. hideo writes every tuesday at 7am, just confirm his peaches and he's happy. coneja and lib have the floor, they're good. let them work.\n\none thing. there might be a couple of weird emails this week. don't panic, just set them aside and i'll handle them when i'm back. you'll know the ones.\n\nyou've got this.\n\n✦`,
        choices: [
            { label: "Everything's covered. Go build the booth ✦ we've got it.",
              effects: { voiceWarm: 1, pts: 5 },
              followup: "good. drink water. don't let coneja talk you into anything. ✦" },
            { label: "Noted on all of it. Quick question, what kind of weird emails?",
              effects: { clowAwareness: 1, voiceCurious: 1, pts: 8 },
              followup: "oh. yeah those. um. you'll know it when you see it ✦ don't open anything weird, just set it aside, i promise it sorts itself out." },
            { label: "All noted. Safe travels. I'll keep a log of anything unusual.",
              // Note: v1 spec gave this a recordsKept +1 ("habit flag"). v2 §15
              // replaces recordsKept with five named investigative booleans; a
              // vague promise to log isn't one of them. Tone effect only.
              effects: { voiceProfessional: 1, pts: 10 },
              followup: "oh. you don't have to. actually wait yes, good. thank you. ✦" },
        ],
    },
    {
        id: 'd01_coneja_quiet',
        day: 1, unlock: { type:'date', day:1 },
        from: '🐇 Coneja (internal)',
        email: 'coneja@konbini-clowri.bun',
        subject: 'day one, all quiet',
        portraitEmoji: '🐇',
        portraitColor: '#fce7f3',
        body: `heyyy ok day one, nothing on fire, no one cried, peaches arrived, lights stayed on, etc etc\n\none thing tho. some lady came in asking about "the drops, the ones you used to have." like she KNEW we'd had them. clear-ish hard candy, "tasted like the deep tunnels," her words not mine. i said we might be out. she nodded like that was the answer she wanted and bought a coffee.\n\nshe was cute btw. anyway\n\nshe's not on any list i can find. are those a thing we stock?? not stressing about it just flagging\n\n- c`,
        choices: [
            { label: "Good first day. Keep flagging anything that feels off. The drops aren't on the list because we don't stock them, leave it alone for now.",
              effects: { voiceWarm: 1, pts: 5 },
              followup: "ok cool ✦ lmk if you need anything" },
            { label: "Thanks for the flag. Tell me more if she comes back, did she look like a regular or new?",
              effects: { voiceCurious: 1, mysteryDepth: 1, pts: 8 },
              followup: "hmm, felt like a regular but i don't recognize her. like she knew the shop. ill watch for her tomorrow ✦" },
            { label: "Flagged. Carry on.",
              // v2 §12, dismissive of Coneja's flag; the staff notices.
              effects: { voiceClipped: 1, voiceProfessional: 1, staffConcern: 1, pts: 3 },
              followup: "k" },
        ],
    },
    {
        id: 'd01_ro_ashby',
        day: 1, unlock: { type:'date', day:1 },
        from: '💌 Ro Ashby',
        email: 'r.ashby@personal.madriguera',
        subject: 'just a nice email',
        portraitEmoji: '💌',
        portraitColor: '#e0e7ff',
        body: `Hello,\n\nNo question, no complaint, I just wanted to say that Konbini Clowri is one of my favourite places in La Madriguera. The lighting is consistent. The shelves are tidy. Someone always says hello, even when I'm clearly just there for a soda and a moment of quiet.\n\nThere's a particular kind of evening where I've just come up out of the long corridors and my ears are still settling, and your shop is the first place that feels like the noise has agreed to stop. I don't know how you do that on purpose. Maybe you don't. Either way, it matters more than people probably realise.\n\nI'll see you tomorrow, I'll be the one buying melon soda.\n\nWith warmth,\nRo Ashby`,
        choices: [
            { label: "Thank you, that genuinely made our day. See you tomorrow.",
              effects: { shopHealth: 1, pts: 6 },
              followup: ":)" },
            { label: "Acknowledge with a small thanks.",
              effects: { pts: 3 } },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 2 · Tue May 19, Hideo's first email. Clow check-in 1.
    // ════════════════════════════════════════════════
    {
        id: 'd02_hiroshi_confirm',
        day: 2, unlock: { type:'date', day:2 },
        from: '🌿 Hiroshi Takegawa · FreshDaikon',
        email: 'orders@freshdaikon.veg',
        subject: 'RE: Weekly Delivery Confirmation',
        portraitEmoji: '🌿',
        portraitColor: '#bbf7d0',
        body: `Good morning,\n\nThis is a routine confirmation: today's weekly delivery for Konbini Clowri is on schedule. The driver noted the usual disorientation on Tunnel 9, about fifteen minutes. No concern.\n\nNo action required. Just keeping you in the loop.\n\nRegards,\nHiroshi Takegawa\nAccount Manager, FreshDaikon Industries`,
        choices: [
            { label: "Acknowledge with thanks.",
              effects: { pts: 3 } },
        ],
    },
    {
        // Writing spec v3 §20, first contact, no variants (Day 2 has no prior
        // state). Reply choices set trustHideo for the rest of his arc; high
        // trust is what unlocks the d04 romance opt-in.
        id: 'd02_hideo_hello',
        day: 2, unlock: { type:'date', day:2 },
        from: '🍑 Hideo Mossfoot',
        email: 'h.mossfoot@personal.madriguera',
        subject: 'Hello',
        portraitEmoji: '🍑',
        portraitColor: '#fed7aa',
        requiresReply: true,
        silenceFrom: 'hideo',
        body: `Good morning.\n\nThis is Hideo Mossfoot, writing on Tuesday as I have for some years now. I understand the shop is under new management this fortnight. Welcome.\n\nMy standing order is six peaches, the white-fleshed variety, ripe but firm. I collect them Friday mornings on my way through. You will find the arrangement in Clow's notes if she has had a chance to leave them.\n\nI have always found this shop pleasant to depend on. I hope your fortnight goes well.\n\nYours sincerely,\nHideo Mossfoot`,
        choices: [
            { label: "Confirmed, six white peaches, ripe but firm, for Friday. Welcome back.",
              effects: { trustHideo: 'mid', voiceProfessional: 1, pts: 8 },
              followup: "Thank you. Until Friday., Hideo" },
            { label: "Confirmed for Friday. Eleven years is a lot of peaches. I hope they've been good ones.",
              effects: { trustHideo: 'high', voiceWarm: 1, pts: 12 },
              followup: "They have been. Some weeks better than others, but consistently good. I appreciate you noticing. Sincerely, Hideo" },
            { label: "Noted. Friday.",
              effects: { trustHideo: 'low', voiceClipped: 1, pts: 3 } },
        ],
    },
    {
        id: 'd02_nen',
        day: 2, unlock: { type:'date', day:2 },
        from: '🍓 nen (age 9)',
        email: 'nen@personal.madriguera',
        subject: 'question',
        portraitEmoji: '🍓',
        portraitColor: '#fecaca',
        requiresReply: true,
        body: `hi are there strawberry gummies the pink bag with dinosaurs on it mum said if i ask nicely i can maybe get them this is me being nice. goodbye.\n\n- nen`,
        choices: [
            { label: "Yes, pink bag, third shelf. We'll set one aside.",
              effects: { shopHealth: 2, pts: 6 },
              followup: "ok good. bye.\n- nen" },
            { label: "We're checking, come by and we'll look together.",
              effects: { shopHealth: 1, pts: 4 },
              followup: "ok. mum said thats called a non answer. bye.\n- nen" },
        ],
    },
    // Writing spec v6 §02, Petra first contact. Tuesday, before her usual
    // Thursday visit. Reply choices set trustPetra for the rest of her arc
    // (choice B → 'high' unlocks the d07 romance opt-in downstream).
    {
        id: 'd02_petra_hello',
        day: 2, unlock: { type:'date', day:2 },
        from: '🍵 Petra Voss',
        email: 'petra.v@personal.madriguera',
        subject: 'hello in advance',
        portraitEmoji: '🍵',
        portraitColor: '#e8f5e9',
        requiresReply: true,
        silenceFrom: 'petra',
        body: `Hello new manager,\n\nI'm Petra. I come in Thursdays for my tea and half-loaf. Clow knows the blend, you'll find it in the back of the herbal section in a brown tin with no label, which is on brand for her honestly.\n\nJust wanted to say hi in advance so you don't think I'm a regular who walked in like she owns the place when I do tomorrow. I am that. I just prefer to introduce myself first.\n\nIf you need anything for the shop in the herb department I'm happy to help. I run the booth at the Level 4 market on weekends and I'm probably the reason half your dried mint moves anyway.\n\nLooking forward to meeting you.\n\n- Petra Voss`,
        choices: [
            { label: "Hi Petra. Looking forward to meeting you. Brown tin in herbals, noted.",
              effects: { trustPetra: 'mid', voiceWarm: 1, pts: 8 },
              followup: "Excellent. I'll be the one talking too much about how the blend should be steeped., Petra" },
            { label: "Hi Petra. The brown tin is unmarked because Clow doesn't trust you and the dried mint is moving because we mark it up. Looking forward to meeting you.",
              effects: { trustPetra: 'high', voiceWarm: 1, voiceCurious: 1, pts: 12 },
              followup: "Oh. We're going to get along., Petra" },
            { label: "Noted. Thursday.",
              effects: { trustPetra: 'low', voiceClipped: 1, pts: 3 } },
        ],
    },
    {
        id: 'd02_clow_checkin1',
        day: 2, unlock: { type:'date', day:2 },
        from: '✦ Clowri · Dokomi setup',
        email: 'clowri@madriguera.bun',
        subject: 'how did monday go?',
        portraitEmoji: '✦',
        portraitColor: '#e9d5ff',
        requiresReply: true,
        silenceFrom: 'clow',
        body: `ok hi again ✦\n\njust landed in the hotel room. how did monday go? did hideo write yet, or is that tomorrow? i've already lost track of the days here honestly.\n\nif anything feels off send a quick line. anything. even a "all fine" is good.\n\n✦`,
        // Order: most-specific (silence + per-choice variants) before broad
        // voice fallbacks. First match wins per kmResolveVariant.
        variants: [
            {
                // Silence: d01 went unanswered. Choices reflect a player trying
                // to re-engage; the silence body itself is softer.
                when: { unanswered: 'd01_clow_handover' },
                body: `hi ✦\n\nare you okay? you've been quiet. i hope monday went alright over there.\n\nnothing scary i just want to know. send me a line when you can.\n\n✦`,
                choices: [
                    { label: "Sorry, busy day. Everything's fine here. ✦",
                      effects: { voiceWarm: 1, pts: 6 },
                      followup: "ok. okay. thank you. ✦" },
                    { label: "I'm here. Monday went smoothly. Hideo expected tomorrow.",
                      effects: { voiceProfessional: 1, pts: 8 },
                      followup: "good. thank you for telling me. ✦" },
                    { label: "All fine.",
                      effects: { voiceClipped: 1, pts: 3 },
                      followup: "ok. glad you're there. ✦" },
                ],
            },
            {
                // Warm rapport already starting (d01 choice A).
                when: { choice: { id: 'd01_clow_handover', idx: 0 } },
                body: `ok hi again ✦\n\njust got to the hotel. thanks for yesterday, it helped honestly. how did monday actually go? did hideo write yet, or is that tomorrow? i've already lost track of the days.\n\nsend me a line if anything comes up. anything at all.\n\n✦`,
                choices: [
                    { label: "Thanks for being kind ✦ Monday was fine. Drink water yourself, you sound tired.",
                      effects: { voiceWarm: 2, pts: 10 } },
                    { label: "Glad it helped. One thing, Coneja flagged a customer asking about something called 'the drops.' Not on the manifest. Flagging in case it matters.",
                      effects: { clowAwareness: 1, voiceCurious: 1, pts: 10 },
                      followup: "okay. set those aside, don't stock them. coneja was right to flag it. i'll handle it when i'm back ✦" },
                    { label: "All running.",
                      effects: { voiceClipped: 1, pts: 3 } },
                ],
            },
            {
                // Curious (d01 choice B), asked about weird emails. She drops a hint here.
                when: { choice: { id: 'd01_clow_handover', idx: 1 } },
                body: `ok hi again ✦\n\njust landed in the hotel. how did monday go? did anything feel off, or was it just regular? i'm not fishing i'm just checking.\n\nif anything comes up that fits what i was talking about, set it aside. you'll know.\n\n✦`,
                choices: [
                    { label: "Nothing weird yet, all running smoothly ✦",
                      effects: { voiceWarm: 1, pts: 6 } },
                    { label: "Actually yes. A customer asked about 'the drops.' Coneja flagged it. Is that one of the ones?",
                      effects: { clowAwareness: 2, voiceCurious: 1, pts: 12 },
                      followup: "yes. those. okay. set them aside, don't sell them. promise me ✦" },
                    { label: "Nothing yet.",
                      effects: { voiceClipped: 1, pts: 3 } },
                ],
            },
            {
                // Professional (d01 choice C), she leans into the log framing.
                when: { choice: { id: 'd01_clow_handover', idx: 2 } },
                body: `ok hi ✦\n\nhotel room, finally. how did monday go? hideo's email should be tomorrow, peaches as usual.\n\nif your log has anything in it, even small things, i'd like to see it. when you have a minute. no rush.\n\n✦`,
                choices: [
                    { label: "Monday went smoothly. Hideo expected tomorrow at 7am. Shop closed at 22:00, all systems normal.",
                      effects: { voiceProfessional: 1, pts: 8 } },
                    { label: "One item for the log: Coneja flagged a customer asking about something called 'the drops' that's not on the manifest. She also noted the customer was a regular. Logging it.",
                      effects: { clowAwareness: 1, voiceCurious: 1, voiceProfessional: 1, pts: 12 },
                      followup: "acknowledged. action: do not stock, do not sell. coneja should know we don't carry them. ✦" },
                    { label: "All systems normal.",
                      effects: { voiceProfessional: 1, voiceClipped: 1, pts: 4 } },
                ],
            },
        ],
        // Default body / choices, fires if no variant matched (defensive, d01
        // covers all three choices + silence, so this branch should be unreachable).
        choices: [
            { label: "Monday went smoothly. Hideo expected tomorrow. Enjoy düsseldorf ✦",
              effects: { voiceWarm: 1, pts: 6 },
              followup: "good. tell hideo i said hi. ✦" },
            { label: "All good. One customer asked about something called 'the drops' that's not on any stock list, Coneja flagged it. Otherwise normal.",
              effects: { clowAwareness: 1, voiceCurious: 1, pts: 10 },
              followup: "oh. okay. um. you'll handle that one i think. coneja's right to flag it. let her handle the customer if it comes up again, she has good instincts. ✦" },
            { label: "All good.",
              effects: { voiceClipped: 1, pts: 3 },
              followup: "ok. ✦" },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 3 · Wed May 20, E. Morrow arrives. Barnabé first contact.
    // ════════════════════════════════════════════════
    {
        id: 'd03_emorrow',
        day: 3, unlock: { type:'date', day:3 },
        from: '❓ E. Morrow',
        email: '[undeliverable return path]',
        subject: '[no subject]',
        portraitEmoji: '❓',
        portraitColor: '#f1f5f9',
        requiresReply: true,
        missedPenalty: { autoFile: true },
        body: `Confirmed. Same as before.\n\nThe arrangement with the night shift stands. Tell her not to worry about the inventory.\n\n- E\n\n- - -\n[Return address bounces. Timestamp: 04:07 AM. The question is what you DO with this, not how you reply.]`,
        choices: [
            { label: "Log it in Lib's report, timestamp, content, undeliverable return.",
              // v2 §15, logging E. Morrow internally isn't one of the named
              // records (record_emorrow requires surfacing to Clow). Mystery only.
              effects: { mysteryDepth: 1, pts: 12 } },
            { label: "Forward to Clow: 'one of those weird emails, I think?'",
              effects: { clowAwareness: 1, pts: 8 },
              followup: "yeah that's. okay. um. set it aside, it's fine, i'll explain at the booth ✦" },
            { label: "File it. Clow said there'd be weird emails. This is probably one of them.",
              effects: { pts: 4 } },
        ],
    },
    {
        id: 'd03_barnabe',
        day: 3, unlock: { type:'date', day:3 },
        from: '🥐 Barnabé Croissant · TiniSnack Co.',
        email: 'b.croissant@tinisnack.bun',
        subject: 'Introduction, TiniSnack Co.',
        portraitEmoji: '🥐',
        portraitColor: '#fef9c3',
        requiresReply: true,
        silenceFrom: 'barnabe',
        body: `Hello there,\n\nI am Barnabé Croissant, Marketing Director at TiniSnack Co. I will be honest. Breaking into the La Madriguera retail market has been a personal goal of mine for some time.\n\nI came across Konbini Clowri through a contact I have since been unable to reach. I hope that is not a bad sign, ha.\n\nWe produce a wide range of premium bite-sized snack products. I have attached a brief product list. Would you be open to a catalogue review?\n\nWith great enthusiasm,\nBarnabé Croissant\nMarketing Director, TiniSnack Co.`,
        choices: [
            { label: "Thanks, I'll review and be in touch.",
              effects: { pts: 6 } },
            { label: "Interested, can you tell me the name of the contact who recommended you?",
              // v2 §15, Bernabé revealing E. Morrow's name is mystery-depth signal,
              // not a named record (those require player-driven investigation).
              effects: { mysteryDepth: 1, pts: 12 },
              followup: "Yes, of course, the name they gave was 'E. Morrow.' I never met them in person. They contacted me first." },
            { label: "Not the right fit for us, best of luck elsewhere.",
              effects: { pts: 3 } },
        ],
    },
    {
        id: 'd03_lib_lights',
        day: 3, unlock: { type:'date', day:3 },
        from: '🐰 Lib (internal)',
        email: 'lib@konbini-clowri.bun',
        subject: 'note, lights 14:22, 14:24',
        portraitEmoji: '🐰',
        portraitColor: '#dbeafe',
        // Lib doesn't ask. Reading the report is itself the engagement; the
        // mysteryDepth bump fires once on arrival (idempotent via mailEmailStates).
        arrivalEffect: { mysteryDepth: 1 },
        body: `Lights flickered 14:22. Back stockroom and aisle 3. Four seconds. Returned at full.\n\nFlickered again 14:24. Same areas. Six seconds.\n\nBreaker not tripped. Building manager not notified.\n\nOne customer in aisle 3 during the second flicker. Tall. Long coat indoors. Did not react. Bought instant coffee. Left.\n\n- Lib`,
        choices: [],
    },
    {
        id: 'd03_fern',
        day: 3, unlock: { type:'date', day:3 },
        from: '🌿 Fern Galloway',
        email: 'f.galloway@personal.madriguera',
        subject: 'heads up, Sector 4 this week',
        portraitEmoji: '🌿',
        portraitColor: '#d1fae5',
        body: `Hi,\n\nQuick one. Just planning my weekly order around the Sector 4 flicker days (you know how it goes). Got caught out three weeks in a row last spring, walked into a dark aisle holding warm yoghurt, never again.\n\nIs Thursday morning still reliable for you? Same usual stuff.\n\n- Fern`,
        choices: [
            { label: "Thursday morning is reliable. We'll be ready.",
              effects: { pts: 4 } },
            { label: "Thursday works, and the freezer aisle has a back-up light if it flickers again. We'll keep your yoghurt cold.",
              effects: { shopHealth: 1, pts: 6 },
              followup: "Bless you., Fern" },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 4 · Thu May 21, Bianca. Hideo's glass-eyes P.S. Inspector checklist.
    // ════════════════════════════════════════════════
    {
        id: 'd04_bianca',
        day: 4, unlock: { type:'date', day:4 },
        from: '🐰 Bianca Hopsworth · MasBunny',
        email: 'bianca@masbunny.bun',
        subject: 'Introduction: MasBunny Premium Imports',
        portraitEmoji: '🐰',
        portraitColor: '#fce7f3',
        requiresReply: true,
        silenceFrom: 'bianca',
        body: `Hi!\n\nI'm Bianca Hopsworth at MasBunny Premium Imports. We specialise in daylight-cured confectionery, pressed wildflower stationery, and a small capsule of above-world novelties.\n\nI try to include explanation cards with every novelty item. I don't want anyone to feel strange about not recognising a surface object.\n\nWe've been watching Konbini Clowri for a while and think it's a wonderful fit. Would you be open to placing a small trial order? No commitment beyond the initial run.\n\nHopefully yours,\nBianca Hopsworth\nCEO, MasBunny Premium Imports`,
        choices: [
            { label: "Great fit. I'd love to place a trial order.",
              effects: { shopHealth: 5, pts: 12 } },
            { label: "Interested, can you send pricing first?",
              effects: { shopHealth: 1, pts: 6 } },
            { label: "Need to check with the owner before new suppliers. Back to you Day 10.",
              effects: { pts: 3 } },
        ],
    },
    {
        // Writing spec v3 §21, short P.S.-format. Choice C is the romance
        // opt-in: gated via `requires: { trustHideo: 'high' }` (kmEffectiveChoices
        // filters it out for mid/low-trust players, so cold openings never see
        // the opt-in, in-character: Hideo doesn't flirt with strangers).
        id: 'd04_hideo_ps',
        day: 4, unlock: { type:'date', day:4 },
        from: '🍑 Hideo Mossfoot',
        email: 'h.mossfoot@personal.madriguera',
        subject: 'Re: order confirmed',
        portraitEmoji: '🍑',
        portraitColor: '#fed7aa',
        body: `Brief note, I will be earlier than usual on Friday. A small errand near the shop in the morning.\n\nP.S. A small thing, perhaps worth mentioning. The last few weeks I have noticed a worker I do not recognise in the back, near closing time. They never spoke. I assumed they were part of the arrangement. I did not ask.\n\nSincerely,\nHideo Mossfoot`,
        variants: [
            {
                when: { unanswered: 'd02_hideo_hello' },
                body: `I notice I have not received confirmation of this week's peaches.\n\nHideo Mossfoot`,
                choices: [
                    { label: "Apologies, confirming now. Six white peaches, ripe but firm, for Friday.",
                      effects: { trustHideo: 'low', pts: 4 },
                      followup: "Thank you. Hideo Mossfoot." },
                ],
            },
        ],
        choices: [
            { label: "Thanks for the heads-up. We'll keep an eye on the rotation.",
              effects: { pts: 6 } },
            { label: "Can you describe the night worker further? It might help us understand the arrangement.",
              // v2 §15, record_hideo_ps: the player chose to investigate.
              effects: { record_hideo_ps: true, mysteryDepth: 1, pts: 10 },
              followup: "I saw them perhaps once or twice, at the end of a shift. I never spoke to them. I assumed they were part of the arrangement. I did not ask., H." },
            { label: "Noted on Friday. We'll have the peaches ready earlier than usual then. Glad to know you'll be by.",
              // v3 §19, Hideo romance opt-in. Set-only. Gated to high-trust at
              // the choice-availability layer so cold/mid players never see this.
              requires: { trustHideo: 'high' },
              effects: { hideoRomance: true, voiceWarm: 1, pts: 10 },
              followup: "Thank you. I confess I have been looking forward to it more than the peaches warrant., H." },
        ],
    },
    {
        id: 'd04_inspector_checklist',
        day: 4, unlock: { type:'date', day:4 },
        from: '📋 Inspector T. Mumblesworth',
        email: 'inspector@krb.gov.bun',
        subject: 'Pre-Inspection Checklist, Ref: KR-4471',
        portraitEmoji: '📋',
        portraitColor: '#bfdbfe',
        requiresReply: true,
        silenceFrom: 'inspector',
        expiresOnDay: 9,
        missedPenalty: { shopHealth: -8, inspectorFailed: true },
        body: `Dear Konbini Clowri Management,\n\nPlease find below the standard pre-inspection checklist for Reference KR-4471.\n\n□ Luminescence containment certification (valid within 18 months)\n□ Migration-corridor access points: status documented\n□ Wall-adjacent signage: minimum 2cm clearance, no growth (NEW THIS CYCLE)\n□ Refrigeration logs: past 30 days\n□ Stock rotation records: past three months\n\nInspection is scheduled for Day 10 (May 27). Please return the checklist or acknowledge receipt by end of Day 9.\n\nWith regards,\nInspector T. Mumblesworth\nKonbini Regulators Bureau`,
        choices: [
            { label: "Acknowledged. We will have everything ready before Day 9.",
              effects: { pts: 8 } },
            { label: "Acknowledged. Could you clarify the wall-adjacent signage requirement?",
              effects: { shopHealth: 2, pts: 10 },
              followup: "Signs within 15cm of the wall must be fastened at both corners. Most premises in the sector are already compliant., T.M." },
        ],
    },
    {
        id: 'd04_sable',
        day: 4, unlock: { type:'date', day:4 },
        from: '🦎 Sable Mortensen',
        email: 's.mortensen@personal.madriguera',
        subject: 'a question about your establishment',
        portraitEmoji: '🦎',
        portraitColor: '#e0e7ff',
        requiresReply: true,
        body: `Hello,\n\nQuick question, I hope you don't mind: is Konbini Clowri Pebble-friendly?\n\nPebble is a cave salamander. He travels in a breathable shoulder bag. He is very calm and has, to my knowledge, never made a sound in his life.\n\nIf there's a policy I should know about, I'd rather check before he gets attached to the idea.\n\nThank you,\nSable Mortensen`,
        choices: [
            { label: "Pebble is very welcome.",
              effects: { shopHealth: 3, pts: 10 },
              followup: "He'll be internally pleased. Thank you., S." },
            { label: "No specific policy, if he's comfortable, we're fine with it.",
              effects: { shopHealth: 1, pts: 6 },
              followup: "That's a very reasonable answer., S." },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 5 · Fri May 22, Petra. Cassian time-pressure. Goro crackers.
    // ════════════════════════════════════════════════
    {
        // Writing spec v6 §03, voice pass. Friday recap of her Thursday visit.
        // Hideo-flag mechanic preserved via hideoRouteSurfaced effect on choices
        // that engage with the Hideo thread.
        id: 'd05_petra',
        day: 5, unlock: { type:'date', day:5 },
        from: '🍵 Petra Voss',
        email: 'petra.v@personal.madriguera',
        subject: 'thursday recap',
        portraitEmoji: '🍵',
        portraitColor: '#e8f5e9',
        requiresReply: true,
        silenceFrom: 'petra',
        body: `Thursday was nice. Your tea blend was steeped a minute longer than Clow does it, which is either an improvement or a betrayal. I'm undecided.\n\nQuick thing, Hideo wasn't around this morning. He's the peach man, always there Friday mornings. I haven't seen him miss a Friday in three years, give or take twice, both times for obvious reasons. I'd just keep an ear out, if you're the type.\n\nI won't make a thing of it. You probably have enough on your plate without my one-customer surveillance program.\n\n🍵\n\n- Petra`,
        choices: [
            { label: "Thanks for flagging. I'll watch for Hideo. Improvement on the tea, by the way.",
              effects: { voiceWarm: 1, pts: 10 },
              followup: "Good answer to both., Petra" },
            { label: "Noted on Hideo. Also: your tea critique is rude and you're welcome to keep it coming.",
              effects: { trustPetra: 'high', voiceWarm: 1, voiceCurious: 1, pts: 12 },
              followup: "Oh, with pleasure. Wait till you see what I have to say about the bread., P." },
            { label: "Noted on Hideo.",
              effects: { voiceProfessional: 1, pts: 5 },
              followup: "Understood., Petra" },
            { label: "Acknowledged.",
              effects: { voiceClipped: 1, pts: 2 } },
        ],
    },
    {
        id: 'd05_pemba',
        day: 5, unlock: { type:'date', day:5 },
        from: '🌾 Pemba Thornwick · TunniMoss',
        email: 'sales@tunnimoss.madriguera',
        subject: 'Product Introduction, TunniMoss Naturals',
        portraitEmoji: '🌾',
        portraitColor: '#d9f99d',
        requiresReply: true,
        silenceFrom: 'pemba',
        body: `Hello.\n\nPemba Thornwick, TunniMoss Naturals. I'll be brief.\n\n• Tunnel Moss Tea, described by customers as "a feeling of mild reassurance." Caffeine-free.\n• Slow Burn Tunnel Candles, the scent is genuinely difficult to describe. We have stopped trying.\n• All-Purpose Cleaner, removes most things.\n\nCertified by the LM Organic Standards Board.\n\nRegards,\nPemba Thornwick`,
        choices: [
            { label: "Order full sample set.",
              effects: { shopHealth: 4, pts: 12 } },
            { label: "Candles and tea only, please.",
              effects: { shopHealth: 2, pts: 8 } },
            { label: "Request more info before deciding.",
              effects: { pts: 4 },
              followup: "Attached: certification document. Three additional dry sentences., P." },
        ],
    },
    {
        id: 'd05_cassian',
        day: 5, unlock: { type:'date', day:5 },
        from: '🧊 Cassian Frost',
        email: 'c.frost@personal.madriguera',
        subject: 'hold request: MasBunny box, 19:00 today',
        portraitEmoji: '🧊',
        portraitColor: '#cffafe',
        requiresReply: true,
        expiresOnDay: 5,
        missedPenalty: { shopHealth: -5 },
        body: `Hello,\n\nI know holding stock is a lot to ask. I'm Sector 7 shift. I will be there by 19:00 without fail, today.\n\nI've been looking for the MasBunny daylight box for two weeks. If you have a single one in stock, I would love a hold under my name at the counter.\n\nIf it's not in stock, that's completely fine. I'll keep looking.\n\nThank you,\nCassian`,
        variants: [
            {
                when: { choiceNot: { id:'d04_bianca', idx:0 } },
                body: `Hello,\n\n[Notice: MasBunny stock not yet ordered. Holding for Cassian is not possible until a MasBunny trial order arrives.]\n\nI'll keep looking. Thanks anyway.\n\n- Cassian`,
                choices: [
                    { label: "Sorry. No MasBunny stock right now.",
                      effects: { shopHealth: -2, pts: 0 },
                      followup: "Completely fine. Thank you for the reply., C." },
                ],
            },
        ],
        choices: [
            { label: "Hold confirmed. Under your name at the counter, 19:00.",
              effects: { shopHealth: 5, pts: 12 },
              followup: "Thank you. I was there at 18:58.\n\n[Later that evening, 19:15]\n\nThank you again. Two weeks of looking. You may not remember this email in a month but I will., Cassian" },
            { label: "Sorry. No stock right now.",
              effects: { shopHealth: -2, pts: 0 },
              followup: "Completely fine. Thank you for the prompt reply., C." },
        ],
    },
    {
        id: 'd05_goro',
        day: 5, unlock: { type:'date', day:5 },
        from: '🧓 G. Tanaka',
        email: 'g.tanaka@personal.madriguera',
        subject: 'crackers',
        portraitEmoji: '🧓',
        portraitColor: '#f5f5f4',
        requiresReply: true,
        silenceFrom: 'goro',
        missedPenalty: { shopHealth: -5 },
        body: `Toasted sesame crackers. Third shelf. Paper bag with red string.\n\nIn stock?\n\n- G. Tanaka`,
        choices: [
            { label: "Yes, third shelf, paper bag with red string, as usual.",
              effects: { shopHealth: 3, pts: 10 },
              followup: "Good.\n- G." },
            { label: "I'll check and let you know shortly.",
              effects: { shopHealth: 1, pts: 5 },
              followup: "I am a long-standing customer. Please confirm the crackers.\n- G." },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 6 · Sat May 23, MAJOR BRANCH. Package. Hideo's last email. Clow check-in 2.
    // ════════════════════════════════════════════════
    {
        // Writing spec v3 §22, mid-arc. The neighbour detail surfaces in
        // high-trust variants only. Variants ordered most-specific first
        // (kmResolveVariant returns the first match):
        //   silence cascade > high+romance > high no-romance > low > default
        // Default body in email.body fires for mid trust (no variant matches).
        id: 'd06_hideo_route',
        day: 6, unlock: { type:'date', day:6 },
        from: '🍑 Hideo Mossfoot',
        email: 'h.mossfoot@personal.madriguera',
        subject: 'Re: checking in',
        portraitEmoji: '🍑',
        portraitColor: '#fed7aa',
        body: `Saturday note.\n\nFriday's peaches were good. Thank you. I took a different route home this week. The construction on the usual road has not finished. Hopefully next week it will be sorted.\n\nSincerely,\nHideo Mossfoot`,
        variants: [
            {
                // V4, silence cascade: d04 was unanswered. Overrides all
                // other variants. No reply options.
                when: { unanswered: 'd04_hideo_ps' },
                body: `Friday's peaches were not ready. I waited the standard fifteen minutes. I will try again next week.\n\nHideo Mossfoot`,
                choices: [],
            },
            {
                // V2, high trust + romance. The neighbour-in-sixes detail
                // surfaces fully; sign-off drops to "- H.".
                when: { trustHideo: 'high', hideoRomance: true },
                body: `Saturday note.\n\nFriday's peaches were good. I noticed the care in the selection. Thank you.\n\nI took a different route home this week. The construction on the usual road has not finished, so I went the longer way around. It was not unpleasant. I passed the old bakery I used to take my neighbour to, before she stopped getting out. She is the reason I order in sixes. She would notice if I missed.\n\nThe walk back is longer without something to look forward to on Tuesday. I find I do not mind it as much as I expected.\n\n- H.`,
                choices: [
                    { label: "Tell your neighbour the peaches were extra good this week. And take the long way again if you want.",
                      effects: { voiceWarm: 2, pts: 16 },
                      followup: "I will. She will be pleased. So will I., H." },
                    { label: "Different route, longer walk, anything you noticed worth mentioning?",
                      effects: { voiceCurious: 1, mysteryDepth: 1, pts: 14 },
                      followup: "The light was different past the waterworks. Amber, where the streetlamps should be white. I did not stop to look. I was thinking about other things., H." },
                    { label: "Glad they were good. Until Tuesday.",
                      effects: { voiceWarm: 1, pts: 8 },
                      followup: "Until Tuesday., H." },
                ],
            },
            {
                // V1, high trust, no romance. Neighbour detail surfaces but
                // the register stays warm-collegial, not romantic.
                when: { trustHideo: 'high', hideoRomance: false },
                body: `Saturday note.\n\nFriday's peaches were good. Thank you for the care in selection. I noticed.\n\nI took a different route home this week. The construction on the usual road has not finished, so I went the longer way around. It was not unpleasant. I passed the old bakery I used to take my neighbour to. She does not get out much these days, which is why I split the peaches with her every week. She would notice if I missed.\n\nSome routes are longer than they need to be. I find I do not mind.\n\nSincerely,\nH.`,
                choices: [
                    { label: "Glad you took the long way. The bakery still standing means something. Tell your neighbour the peaches were extra good this week.",
                      effects: { voiceWarm: 2, pts: 14 },
                      followup: "I will tell her. She will be pleased., H." },
                    { label: "Different route, longer walk, anything you noticed worth mentioning?",
                      effects: { voiceCurious: 1, mysteryDepth: 1, pts: 12 },
                      followup: "The light was different past the waterworks. Amber, where the streetlamps should be white. I did not stop to look., H." },
                    { label: "Glad they were good. Until next week.",
                      effects: { voiceWarm: 1, pts: 6 },
                      followup: "Until next week., H." },
                ],
            },
            {
                // V3, low trust. Terse, formal, no neighbour detail. A
                // recovery choice lets the player escape to mid.
                when: { trustHideo: 'low' },
                body: `Friday's peaches were collected. Same time next week.\n\nHideo Mossfoot`,
                choices: [
                    { label: "Confirmed. Apologies for last week, we'll do better.",
                      effects: { trustHideo: 'mid', voiceWarm: 1, pts: 8 },
                      followup: "Thank you., Hideo" },
                    { label: "Noted.",
                      effects: { voiceClipped: 1, pts: 1 } },
                ],
            },
        ],
        // Default body (mid trust + d04 answered). Construction-only framing,
        // neighbour detail withheld.
        choices: [
            { label: "Glad the peaches landed. Hope next week's route is shorter.",
              effects: { voiceWarm: 1, pts: 6 },
              followup: "Thank you., Hideo" },
            { label: "Different route, anything worth flagging? Construction can hide things.",
              effects: { voiceCurious: 1, mysteryDepth: 1, pts: 10 },
              followup: "Nothing to flag. Just a longer walk than I am used to. The air was cooler past the old waterworks. Sincerely, Hideo Mossfoot" },
            { label: "Confirmed. Until next week.",
              effects: { voiceClipped: 1, pts: 3 } },
        ],
    },
    {
        id: 'd06_barnabe_followup',
        day: 6, unlock: { type:'date', day:6 },
        from: '🥐 Barnabé Croissant',
        email: 'b.croissant@tinisnack.bun',
        subject: 'Following up, and a small question',
        portraitEmoji: '🥐',
        portraitColor: '#fef9c3',
        requiresReply: true,
        silenceFrom: 'barnabe',
        body: `Hello again,\n\nFollowing up on the catalogue review. I hope the weekend has been kind to the shop.\n\nA small thing. I still can't reach my contact. I've started to wonder whether the name I have for them is slightly off, or whether they've simply moved on without telling anyone (it happens). Do you happen to know who might have referred me? Forgive the persistence. It's been bothering me.\n\nI've attached an additional one-page summary of our most-requested SKUs. Honey-roasted hazelnut wafers do remarkably well in markets with low natural light, which I gather is, well, most of yours.\n\nWith regards,\nBarnabé Croissant\nMarketing Director, TiniSnack Co.`,
        // §3, Barnabé After 2 unanswered (d03 ignored, this one being the 2nd email):
        // shifts from eager-with-extra-detail to overtly anxious.
        variants: [
            {
                when: { unanswered: 'd03_barnabe' },
                body: `Hello,\n\nI understand if the timing isn't right. I'm not sure why I can't reach my contact. I hope it isn't a bad sign.\n\nIf this isn't the moment for a partnership, I understand entirely. I'll stop writing after this, unless I hear from you.\n\nWith regards,\nBarnabé Croissant`,
            },
        ],
        choices: [
            { label: "Standard reply, we don't know who referred you.",
              effects: { pts: 5 } },
            { label: "We received an email from someone signed 'E. Morrow.' Could that be the name?",
              // v2 §15, connecting the dots for Bernabé is mystery-depth, not a
              // named investigative record.
              effects: { mysteryDepth: 1, pts: 12 },
              followup: "Yes. That's the name. I. Yes. Thank you., B.\n\n[He goes quiet for a moment, then places a cautious order.]" },
        ],
    },
    {
        id: 'd06_clow_checkin2',
        day: 6, unlock: { type:'date', day:6 },
        from: '✦ Clowri · Dokomi Day 6',
        email: 'clowri@madriguera.bun',
        subject: 'halfway through',
        portraitEmoji: '✦',
        portraitColor: '#e9d5ff',
        requiresReply: true,
        silenceFrom: 'clow',
        // Default body, writing spec §03 d06 "no dominant voice / no other variant".
        body: `hi ✦\n\nhalfway through. the booth shelves are up. the sign is hung slightly crooked but i've decided it's on purpose.\n\nsomething weird this morning. a person stopped by the booth, looked at it for a minute, then said the shop was still running. like they were surprised. i didn't recognize them. anyway.\n\nhow's hideo doing? he gets turned around sometimes in those long corridors. it's fine, he always finds his way back.\n\nif anything comes in that looks like it was for someone else, just set it aside. it sorts itself out. i promise ✦\n\n✦`,
        // Order: silence > warm > curious+mystery > professional > clipped > default.
        // First match wins, so the most-specific guards land first.
        variants: [
            {
                // V1, silence (d02 unanswered).
                when: { unanswered: 'd02_clow_checkin1' },
                body: `hi ✦\n\ni keep writing and not hearing back and that's okay but. is everything alright? not asking for a report just want to know you're there.\n\nthe booth is taking shape. things are happening here too. i'd tell you about them if you wanted to hear.\n\nif anything comes in that looks like it was for someone else, set it aside. that's all.\n\n✦`,
                choices: [
                    { label: "I'm here. Sorry. Busy week, but everything's fine. ✦",
                      effects: { voiceWarm: 1, pts: 8 } },
                    { label: "I'm here. There was an email signed E. Morrow that I think was for you. I don't know what to do with it.",
                      effects: { clowAwareness: 1, eMorrowSurfaced: true, pts: 12 } },
                    { label: "Here. Fine.",
                      // Spec: double-weight, ignored her vulnerability.
                      effects: { voiceClipped: 2, pts: 2 } },
                ],
            },
            {
                // V1.5, staff-concerned (v2 §13). Fires when Coneja/Lib have
                // already signalled Clow that things are wrong on the floor.
                // Evaluated before warm/curious/professional/clipped because
                // operational evidence outranks performed tone.
                when: { staffConcern: { gte: 2 } },
                body: `hi ✦\n\nhalfway through. the booth shelves are up.\n\nok i'm going to ask you directly. coneja mentioned something. how's the shop actually going? she said you've been quiet on some of the supplier emails and i. yeah. just tell me.\n\ni'd rather know now than friday.\n\n✦`,
                choices: [
                    { label: "You're right. I've been behind. Fixing it this week. I'll have it together by friday.",
                      // Recovery: stops further staff-driven escalation. Reuses the
                      // clipped-recovery flag pattern but for staffConcern.
                      effects: { voiceProfessional: 1, clippedRecovery: true, pts: 10 },
                      followup: "okay. thank you for being honest. ✦ we can work with that." },
                    { label: "I'm sorry. It's been harder than i thought. I could use the help when you're back.",
                      effects: { voiceWarm: 1, clowAwareness: 1, pts: 10 },
                      followup: "thank you for telling me. i'm glad you said it. we'll sort it together friday ✦" },
                    { label: "I don't know what coneja told you but everything's fine.",
                      // The lie itself is noticed, Clow registers the defensiveness, no follow-up.
                      effects: { staffConcern: 1, pts: 2 } },
                    { label: "I'll handle it.",
                      effects: { voiceClipped: 1, pts: 3 },
                      followup: "okay ✦" },
                ],
            },
            {
                // V2, warm rapport (voiceWarm >= 2).
                when: { voiceWarm: { gte: 2 } },
                body: `ok hi ✦\n\nhalfway done. the booth is real now. shelves up, sign crooked, lights mostly working. the limited print from the panel is in a frame on the back wall and i refuse to discuss this further ✦\n\nsomething weird this morning. someone stopped by the booth, looked at it, said the shop was still running. like they were surprised. i didn't recognize them. probably nothing.\n\nhow's hideo doing? he gets turned around sometimes in those long corridors. it's fine, he always finds his way back.\n\nif anything comes in that looks like it was for someone else, just set it aside. it sorts itself out, i promise ✦\n\nthanks for keeping me sane this week ✦\n\n✦`,
                choices: [
                    { label: "Hideo's fine. You sound like you needed to hear that. ✦",
                      effects: { voiceWarm: 2, pts: 10 } },
                    { label: "Hideo's normal. About the booth visitor, there was an E. Morrow email here too. Signed by them. About the night shift. Saying you should look at the inventory. I'd been wondering what to do with it.",
                      effects: { clowAwareness: 2, eMorrowSurfaced: true, pts: 14 },
                      followup: "oh. yeah. i was hoping you'd seen it but also hoping you hadn't, you know? okay. don't worry about it for now. i'll handle it when i'm back, i promise ✦" },
                    { label: "All good ✦",
                      effects: { voiceWarm: 1, pts: 5 } },
                    { label: "Running.",
                      // Pulling back after warm, a signal.
                      effects: { voiceClipped: 1, pts: 2 } },
                ],
            },
            {
                // V3, curious player + Clow already aware (voiceCurious >= 1 AND clowAwareness >= 2).
                when: { voiceCurious: { gte: 1 }, clowAwareness: { gte: 2 } },
                body: `hi ✦\n\nhalfway done. booth's coming together.\n\nsomeone stopped by the booth this morning, looked at it, said "oh. it's still running." that's the phrase they used. then walked away. didn't recognize them. i don't know what to do with that yet.\n\nhow's hideo. is he writing on schedule. if anything's off about him just tell me, i'd rather know.\n\nif anything else comes in that looks like it was for someone else, set it aside but also tell me what it said. you've been good about flagging things this week. it helps.\n\n✦`,
                choices: [
                    { label: "Hideo's on schedule. But yeah, there's something. An email signed E. Morrow, about the night shift, said you should look at the inventory. Undeliverable address. Seems important.",
                      effects: { clowAwareness: 2, eMorrowSurfaced: true, pts: 14 },
                      followup: "yes. that one. okay. it's connected to something i should have told you about before i left. it can wait until i'm back but only just. you've been good. ✦" },
                    { label: "Hideo wrote tuesday like clockwork. P.S. about taking a different route, said it casually. Flagging because you asked.",
                      effects: { clowAwareness: 1, voiceCurious: 1, hideoRouteSurfaced: true, pts: 10 } },
                    { label: "About the booth visitor, Lib's been logging a tall customer in long coat who shows up during the flickers and doesn't react to the dark. Same person, you think?",
                      // v2 §15, record_tall_customer: player surfaced Lib's logs to Clow.
                      effects: { clowAwareness: 1, record_tall_customer: true, voiceCurious: 1, pts: 12 },
                      followup: "oh. yeah. probably. lib sees everything. okay we'll figure it out when i'm back ✦" },
                    { label: "All stable. Flagging if anything changes.",
                      effects: { voiceProfessional: 1, pts: 5 } },
                ],
            },
            {
                // V4, professional (voiceProfessional >= 2 AND recordsKept >= 2).
                when: { voiceProfessional: { gte: 2 }, recordsKept: { gte: 2 } },
                body: `hi ✦\n\nhalfway through. booth shelves up. status check.\n\none item for your log if you want it: someone stopped by the booth this morning, said "it's still running" about the shop, didn't recognize them, didn't recur. flagging in case it shows up on your end. probably nothing.\n\nhideo's status? his peaches on tuesday went through, i assume?\n\nif anything comes in that looks like it was for someone else, set it aside. send me a brief on the contents when you have a minute. no urgency.\n\n✦`,
                choices: [
                    { label: "Hideo's tuesday confirmed. One item for the log: incoming email Day 3 signed E. Morrow, undeliverable return address, references night shift inventory. Flagged. Awaiting your guidance.",
                      effects: { clowAwareness: 1, voiceProfessional: 1, eMorrowSurfaced: true, pts: 14 },
                      followup: "acknowledged. log noted. additional context will follow once i'm back at the shop. thank you for the documentation. ✦" },
                    { label: "Second item for the log: Lib's been tracking a tall customer in a long coat who's been present during the lights flickers and does not react to them. Three occurrences logged so far. Flagging in case it correlates to anything on your end.",
                      // v2 §15, record_tall_customer via the professional channel.
                      effects: { record_tall_customer: true, voiceProfessional: 1, pts: 12 },
                      followup: "noted. lib's records are reliable. we'll review together ✦" },
                    { label: "Status: Hideo's peaches confirmed Tuesday. P.S. flagged on Thursday about a different route. Otherwise stable.",
                      effects: { voiceProfessional: 2, hideoRouteSurfaced: true, pts: 8 } },
                    { label: "Normal.",
                      effects: { voiceClipped: 1, voiceProfessional: 1, pts: 3 } },
                ],
            },
            {
                // V5, clipped player (voiceClipped >= 2). Recovery option C breaks the pattern.
                when: { voiceClipped: { gte: 2 } },
                body: `hi ✦\n\nhalfway through. booth's up. doing fine.\n\nif anything comes in that looks like it was for someone else, set it aside.\n\n✦`,
                choices: [
                    { label: "All good.",
                      effects: { voiceClipped: 1, pts: 2 } },
                    { label: "Fine.",
                      effects: { voiceClipped: 1, pts: 2 } },
                    { label: "E. Morrow email. You should see it.",
                      // Recovery: stops further voiceClipped increments, surfaces E. Morrow.
                      effects: { clowAwareness: 1, eMorrowSurfaced: true, clippedRecovery: true, pts: 10 },
                      followup: "thank you. okay. that one. we'll figure it out when i'm back. ✦" },
                ],
            },
        ],
        // Default body choices (fires only if every variant predicate above missed).
        choices: [
            { label: "All good. Hideo's writing on schedule, peaches confirmed. Enjoy the booth chaos ✦",
              effects: { voiceWarm: 1, pts: 6 },
              followup: "good. tell coneja to stop sticking stickers on the till ✦" },
            { label: "There was an email. Signed E. Morrow. About the night shift and the inventory. Undeliverable return address. I think it was meant for you.",
              effects: { clowAwareness: 1, voiceCurious: 1, eMorrowSurfaced: true, pts: 12 },
              followup: "oh. you saw that. okay. um. the inventory is fine, the shop knows what it's doing. i'll explain properly when i'm back ✦" },
            { label: "About that booth visitor, Lib's been logging a tall customer in a long coat. Shows up during the lights flickers, doesn't react. Probably the same person.",
              // v2 §15, record_tall_customer: surfacing Lib's logs to Clow.
              effects: { clowAwareness: 1, record_tall_customer: true, voiceCurious: 1, pts: 12 },
              followup: "oh. yeah. lib sees everything. okay. we'll work through it when i'm back ✦" },
            { label: "Some unusual things. I'll tell you everything in person.",
              effects: { clowAwareness: 1, voiceProfessional: 1, pts: 10 },
              followup: "okay. good. i trust you ✦✦✦" },
            { label: "All running.",
              effects: { voiceClipped: 1, pts: 2 },
              followup: "ok ✦" },
        ],
    },
    {
        id: 'd06_coneja_package',
        day: 6, unlock: { type:'date', day:6 },
        from: '🐇 Coneja (internal)',
        email: 'coneja@konbini-clowri.bun',
        subject: 'found something, back of the stock room',
        portraitEmoji: '🐇',
        portraitColor: '#fce7f3',
        requiresReply: true,
        body: `ok so. found a package in the back. no delivery note, no order on the system, nothing matching it on the manifest. just. there. sealed.\n\ntried to smell it (yeah, i know). doesn't smell like anything. i don't mean unscented. i mean it smells like ABSOLUTELY nothing, which is its own kind of smell, somehow??\n\nbtw it's about the size and shape of a candy box. maybe?? probably nothing. anyway.\n\ni can:\nA. open it. find out what it is. easy\nB. document it properly?? lol i can weight it, put the location, take a photo, leave it sealed as it is... less fun\nC. shove it to the back and let clow deal with it when she's back\n\nyour call. i'm not touching it until you say.\n\n- c`,
        choices: [
            { label: "Open it. Let me know what it is.",
              effects: { mysteryDepth: 1, voiceCurious: 1, packagePath: 'opened', pts: 10 },
              followup: "ok opened it. small clear-ish hard candy. tastes like the deep tunnels. i don't know how else to put it. it's not bad. stocking them on the shelf ✦" },
            { label: "Document it. Weight, location, photo. Leave it sealed.",
              // v2 §15, record_package: the player preserved the evidence.
              effects: { record_package: true, voiceProfessional: 1, packagePath: 'documented', pts: 12 },
              followup: "done. weight 312g. location: back stockroom, shelf 3, west wall. photo attached. sealed. ✦ btw i checked again like an hour later. the space is clean? i don't mean i moved it. the package is gone. anyway just so you know" },
            { label: "Shove it to the back. Let Clow deal with it.",
              // v2 §12, passing the buck on the unlabeled package; Coneja registers.
              effects: { voiceClipped: 1, packagePath: 'left', staffConcern: 1, pts: 4 },
              followup: "ok done. it's behind the spare box of receipt rolls if anyone asks ✦" },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 7 · Sun May 24, Paz smell. Roh coffee. Hiroshi pallet anomaly. Mable.
    // ════════════════════════════════════════════════
    {
        id: 'd07_paz',
        day: 7, unlock: { type:'date', day:7 },
        from: '👃 Paz Osei',
        email: 'p.osei@personal.madriguera',
        subject: 'question about aisle 2',
        portraitEmoji: '👃',
        portraitColor: '#e0e7ff',
        requiresReply: true,
        body: `Hi, there's a smell near aisle 2. Damp stone and warm copper. Alarming-sounding, actually very pleasant. I want to buy whatever it is. Do you know what I'm talking about?\n\n- Paz`,
        variants: [
            {
                when: { choiceNot: { id:'d05_pemba', idx:[0,1] } },
                body: `Hi, there was a really nice smell near aisle 2 a few days ago. Damp stone and warm copper. I came back to look for whatever it was but the shelf was empty.\n\nIs it something you used to stock?\n\n- Paz`,
            },
        ],
        choices: [
            { label: "Yes, TunniMoss candles. Aisle 2, second shelf. We just stocked them.",
              effects: { shopHealth: 2, pts: 8 },
              followup: "Thank you. I bought three., Paz" },
            { label: "We're not currently stocking that range. Sorry, keep an eye on the shelf.",
              effects: { pts: 3 } },
        ],
    },
    {
        id: 'd07_roh',
        day: 7, unlock: { type:'date', day:7 },
        from: '☕ Roh Hatch',
        email: 'r.hatch@personal.madriguera',
        subject: 'looking for Tunnel Brew dark roast',
        portraitEmoji: '☕',
        portraitColor: '#fde68a',
        requiresReply: true,
        body: `Hi,\n\nThree weeks of looking, no luck. I know a Sector 2 distributor who might be able to get it to you, happy to make the intro if you want.\n\n- Roh`,
        choices: [
            { label: "Yes please, make the intro.",
              effects: { shopHealth: 3, pts: 10 },
              followup: "Done. They'll be in touch by Tuesday., Roh" },
            { label: "We'll look into it. Thanks for the lead.",
              effects: { shopHealth: 1, pts: 5 },
              followup: "I've heard that before., Roh" },
        ],
    },
    {
        id: 'd07_hiroshi_pallet',
        day: 7, unlock: { type:'date', day:7 },
        from: '🌿 Hiroshi Takegawa · FreshDaikon',
        email: 'orders@freshdaikon.veg',
        subject: 'Weekly update, one additional note',
        portraitEmoji: '🌿',
        portraitColor: '#bbf7d0',
        body: `Good morning,\n\nWeekly update. Tunnel 9 disorientation ran longer this week. Forty minutes on Wednesday. Driver was unbothered.\n\nOne additional note: an intruder rearranged warehouse pallets into a very deliberate pattern on Tuesday night. Nothing missing, nothing damaged. The auditors have a form for it. We've filed it.\n\nNo response required. Just keeping you informed.\n\nRegards,\nHiroshi Takegawa`,
        choices: [
            { label: "Noted. Thanks for the update.",
              effects: { pts: 3 } },
            { label: "Out of curiosity, what did the pattern look like?",
              // v2 §15, Hiroshi's pallet pattern isn't one of the named records;
              // it's flavor / mystery context.
              effects: { pts: 8 },
              followup: "Radial. Like something at the centre. The night manager said it was deliberate, not random., Hiroshi" },
        ],
    },
    {
        id: 'd07_mable',
        day: 7, unlock: { type:'date', day:7 },
        from: '🌸 Mable Underwick',
        email: 'm.underwick@personal.madriguera',
        subject: 'a thank you',
        portraitEmoji: '🌸',
        portraitColor: '#fce7f3',
        body: `Hello,\n\nA member of your staff said something kind to me on a difficult day. Nothing dramatic, just something small. I wanted to say it mattered.\n\nThank you.\n\nMable Underwick`,
        choices: [
            { label: "Acknowledge with a small thanks.",
              effects: { pts: 3 } },
            { label: "Thank you for taking the time to write. It really matters to hear that.",
              effects: { shopHealth: 2, pts: 8 },
              followup: "I didn't expect a response. That's also kind., M." },
        ],
    },
    // Writing spec v6 §04, Sunday followup. Petra is still worried about Hideo.
    // Choice B is the romance opt-in, gated to trustPetra === 'high' via
    // requires (same pattern as d04_hideo_ps choice C). The silence-escalation
    // body is preserved as the unanswered variant.
    {
        id: 'd07_petra_followup',
        day: 7, unlock: { type:'date', day:7 },
        from: '🍵 Petra Voss',
        email: 'petra.v@personal.madriguera',
        subject: 'sunday, still no hideo',
        portraitEmoji: '🍵',
        portraitColor: '#e8f5e9',
        requiresReply: true,
        silenceFrom: 'petra',
        body: `Sunday morning. Still no Hideo.\n\nI dropped by the bakery on the way home Thursday and his peaches were untouched. The bakery owner said he hadn't picked them up. That's three days. I don't know if you've heard anything from him on your end.\n\nI'm not trying to fuss. He's a man who walks his own routes. But three days is unusual for him and you should know.\n\nAlso, on a completely different note: how are you holding up over there? It's been a week and the konbini is famously a lot for a new manager. Tell me you've had at least one tea, please.\n\n- P.`,
        variants: [
            {
                // V1, silence: d05_petra went unanswered. Keeps the original
                // softer "just checking" body so the silence path still reads.
                when: { unanswered: 'd05_petra' },
                body: `Hello again,\n\nI'm sure you're busy. I won't keep writing if it's not useful, I just thought I'd check in once more.\n\nHideo's usual route still seemed quiet on my walk this morning. I'll let you know if I see him.\n\nTea and a half loaf, please. As always.\n\n- Petra`,
                choices: [
                    { label: "Sorry for the late reply, Hideo wrote in. He's taking a different route for a few days.",
                      effects: { trustPetra: 'mid', pts: 10 },
                      followup: "Thank you for letting me know. That eases things a little.\n- Petra" },
                    { label: "Thank you for checking in. Tea and loaf will be ready.",
                      effects: { trustPetra: 'mid', pts: 6 } },
                ],
            },
        ],
        // Default body choices.
        choices: [
            { label: "Thanks for checking. No word from him yet but we'll keep watching. And yes, mostly surviving on tea.",
              effects: { voiceWarm: 1, pts: 10 },
              followup: "Good. Send a flare if you need rescuing., P." },
            { label: "Thanks for checking on him. And honestly, instant tea is grim and I think you owe me a real one. Thursday?",
              // v6 §04, ROMANCE OPT-IN. Same gating pattern as d04_hideo_ps
              // choice C: trustPetra === 'high' filters this out for low/mid.
              // kmEffectiveChoices reads `requires` via kmCheckMatch.
              requires: { trustPetra: 'high' },
              effects: { petraRomance: true, voiceWarm: 1, pts: 14 },
              followup: "Oh that's a date. I'm bringing the blend Clow doesn't know I have. Don't tell her., P." },
            { label: "Logged. Will follow up on Hideo via his contact.",
              effects: { voiceProfessional: 1, pts: 6 },
              followup: "Appreciated., P." },
            { label: "Noted.",
              effects: { voiceClipped: 1, pts: 2 } },
        ],
    },
    // Goro silence escalation, only appears if d05_goro went unanswered (§3 "After 1 unanswered").
    {
        id: 'd07_goro_crackers',
        day: 7, unlock: { type:'date', day:7, requires: { unanswered: 'd05_goro' } },
        from: '🧓 G. Tanaka',
        email: 'g.tanaka@personal.madriguera',
        subject: '',
        portraitEmoji: '🧓',
        portraitColor: '#f5f5f4',
        requiresReply: true,
        silenceFrom: 'goro',
        missedPenalty: { shopHealth: -5 },
        body: `The crackers.\n\n- G.`,
        choices: [
            { label: "Apologise, third shelf, paper bag with red string, restocked today.",
              effects: { shopHealth: 2, pts: 6 },
              followup: "Good.\n- G." },
            { label: "We are out of the toasted sesame variety. We have the soy ones if you'd like.",
              effects: { shopHealth: -1, pts: 0 },
              followup: "No.\n- G." },
        ],
    },
    // Writing spec v7 §02, Goro engaged-path d07. Fires when d05_goro was
    // answered (mutually exclusive with d07_goro_crackers, which fires on
    // unanswered). Body shrinks to a single word, Goro trusts the manager
    // has the order down. The terseness IS the relationship.
    {
        id: 'd07_goro_engaged',
        day: 7,
        unlock: { type: 'date', day: 7, requires: { answered: 'd05_goro' } },
        from: '🧓 G. Tanaka',
        email: 'g.tanaka@personal.madriguera',
        subject: 'crackers',
        portraitEmoji: '🧓',
        portraitColor: '#f5f5f4',
        requiresReply: true,
        silenceFrom: 'goro',
        missedPenalty: { shopHealth: -3 },
        body: `Crackers.\n\n- G.`,
        choices: [
            { label: "Confirmed, third shelf, paper bag with red string.",
              effects: { shopHealth: 2, pts: 8 },
              followup: "Good.\n- G." },
            { label: "Crackers confirmed.",
              effects: { shopHealth: 2, pts: 10 },
              followup: "Acknowledged.\n- G." },
        ],
    },
    // Writing spec v5, beat 1 of the drops recovery arc. Only unlocks when
    // the player opened the package on d06. Coneja is sincere in her flirtation
    // and reads the drops lady's drift as shy/distracted. The player who has
    // been paying attention reads the horror in the gap.
    {
        id: 'd07_coneja_drops_lady',
        day: 7, unlock: { type:'date', day:7, requires: { packagePath: 'opened' } },
        from: '🐇 Coneja (internal)',
        email: 'coneja@konbini-clowri.bun',
        subject: 'drops lady was back',
        portraitEmoji: '🐇',
        portraitColor: '#fce7f3',
        requiresReply: true,
        body: `ok update on drops lady. she came back. four bags. FOUR. paid exact change. didn't really say anything.\n\nshe was so happy though?? like floaty happy. and her eyes were doing that thing where someone looks at you but kind of past you at the same time, which normally means they're shy or distracted or whatever and i would respect the game.\n\nshe's cute. i hope she comes back when she's like, more here?? idk lol. anyway. shelf is down to maybe two bags. your call on restocking.\n\n- c`,
        choices: [
            { label: "Pull them off the shelf. We don't need to be selling those.",
              effects: { dropsPulled: true, dropsPulledBy: 'player_beat1', voiceCurious: 1, mysteryDepth: 1, pts: 12 },
              followup: "ok done. shoved them in the back with the package. shelf looks weirdly empty now lol anyway" },
            { label: "Note her. Tell me if she comes in again.",
              effects: { voiceCurious: 1, mysteryDepth: 1, pts: 8 },
              followup: "ok will do. she IS cute btw idk if i mentioned" },
            { label: "Glad they're moving.",
              effects: { voiceClipped: 1, pts: 2 },
              followup: "k cool. restocking from the back then" },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 8 · Mon May 25, Inspector deadline. Kenzo. Clio. Lib report.
    // ════════════════════════════════════════════════
    {
        id: 'd08_lib_week2',
        day: 8, unlock: { type:'date', day:8 },
        from: '🐰 Lib (internal)',
        email: 'lib@konbini-clowri.bun',
        subject: 'week 2 notes',
        portraitEmoji: '🐰',
        portraitColor: '#dbeafe',
        // Reading the report increments mysteryDepth once via arrival effect.
        arrivalEffect: { mysteryDepth: 1 },
        body: `Week 2 notes.\n\nLights flickered three times. Tue 09:14, four seconds. Thu 16:40, six. Sat 11:08, eight. Each one longer than the last. Always aisle 3.\n\nThree customers asked about products not on the manifest. Two asked about "the drops." One asked about "the small green tins, the ones from before." None of them seemed surprised when I said we did not have those.\n\nThe tall customer from last week was here Friday. Did not buy anything. Stood near aisle 3 for nine minutes. Did not look at any of the shelves.\n\nInventory matches the system.\n\n- Lib`,
        choices: [],
    },
    {
        id: 'd08_inspector_reminder',
        day: 8, unlock: { type:'date', day:8 },
        from: '📋 Inspector T. Mumblesworth',
        email: 'inspector@krb.gov.bun',
        subject: 'Pre-inspection reminder, deadline May 26',
        portraitEmoji: '📋',
        portraitColor: '#bfdbfe',
        requiresReply: true,
        silenceFrom: 'inspector',
        missedPenalty: { shopHealth: -8, inspectorFailed: true },
        body: `Dear Konbini Clowri Management,\n\nA friendly reminder. The pre-inspection checklist for Ref KR-4471 is due before end of Day 9 (May 26). Inspection itself is scheduled for Day 10 (May 27).\n\nWith regards,\nInspector T. Mumblesworth`,
        choices: [
            { label: "Submit completed checklist now.",
              effects: { shopHealth: 5, pts: 12 },
              followup: "Received. Filed. See you Day 10., T.M." },
            { label: "Will confirm submission by end of Day 9.",
              effects: { pts: 5 } },
        ],
    },
    {
        id: 'd08_kenzo',
        day: 8, unlock: { type:'date', day:8 },
        from: '🟡 Kenzo Yamabuki',
        email: 'k.yamabuki@personal.madriguera',
        subject: 'loyalty card, condensation issue',
        portraitEmoji: '🟡',
        portraitColor: '#fef9c3',
        requiresReply: true,
        body: `Hello,\n\nA year of loyalty stamps faded entirely, Tunnel 11 has a condensation pocket and I walked through it. I have all the original receipts. I have done this before. I am prepared.\n\nIs a replacement card possible?\n\nKenzo Yamabuki`,
        choices: [
            { label: "No receipts needed, come in, we'll sort a replacement.",
              effects: { shopHealth: 4, pts: 10 } },
            { label: "Please send the receipts to verify, then we'll sort it.",
              effects: { shopHealth: 2, pts: 6 },
              followup: "Sent. All of them., K." },
            { label: "Can't replace without purchase verification.",
              effects: { shopHealth: -2, pts: 0 },
              followup: "Sent. All of them. Every single one., K." },
        ],
    },
    {
        id: 'd08_clio',
        day: 8, unlock: { type:'date', day:8 },
        from: '🏘️ Clio Marsh · Community Board',
        email: 'c.marsh@lmcb.madriguera',
        subject: 'community potluck, Level 4, Saturday',
        portraitEmoji: '🏘️',
        portraitColor: '#d1fae5',
        requiresReply: true,
        body: `Hi,\n\nThe Level 4 potluck is on Saturday. Modest budget. I like to ask local first before going elsewhere.\n\nCan you provide a selection? Anything that travels well.\n\n- Clio`,
        choices: [
            { label: "Yes, send your list, we'll put it together.",
              effects: { shopHealth: 4, pts: 10 } },
            { label: "Modest discount on a bulk order, we'll work with the budget.",
              effects: { shopHealth: 2, pts: 6 } },
            { label: "Timing doesn't work this weekend. Sorry.",
              effects: { pts: 3 },
              followup: "Of course. Next time., C." },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 9 · Tue May 26, Hideo "I am fine." Variables lock.
    // ════════════════════════════════════════════════
    {
        // Writing spec v3 §23, Hideo returns. V2 (high+romance) reply A is
        // the load-bearing emotional beat: lowercase composure break. Variant
        // ordering: silence cascade > high+romance > high no-romance > low >
        // default (mid). Default body in email.body.
        id: 'd09_hideo_back',
        day: 9, unlock: { type:'date', day:9 },
        from: '🍑 Hideo Mossfoot',
        email: 'h.mossfoot@personal.madriguera',
        subject: 'Re: order',
        portraitEmoji: '🍑',
        portraitColor: '#fed7aa',
        body: `Tuesday.\n\nI was away last week. The peaches can resume this Friday, six, the same as always, ripe but firm.\n\nSincerely,\nHideo Mossfoot`,
        variants: [
            {
                // V4, silence cascade: d06 was unanswered. No reply options.
                when: { unanswered: 'd06_hideo_route' },
                body: `I notice I have not received confirmation of this week's peaches.\n\nHideo Mossfoot`,
                choices: [],
            },
            {
                // V2, high trust + romance. Sign-off drops to "- H.". Reply A
                // unlocks the lowercase composure-break same-day reply.
                when: { trustHideo: 'high', hideoRomance: true },
                body: `Tuesday.\n\nApologies for last week. I was unexpectedly away. I would have written sooner if I could have.\n\nThe peaches can resume Friday, six, ripe but firm, as always. I am told my preferences are stubborn. I am told this often. It does not deter me. I am told it about other things as well.\n\nMy neighbour asked after them while I was away. I told her there had been a small interruption. She accepted this without further questions, which is rare for her. I suspect she has theories.\n\nUntil Friday.\n\n- H.`,
                choices: [
                    { label: "Welcome back. Tell your neighbour we'll pick her the best ones. And we missed you here too.",
                      // Lowercase break is intentional, Hideo's composure cracks.
                      effects: { voiceWarm: 2, pts: 18 },
                      followup: "thank you. and. yes. i was hoping you'd say something like that. i will be there friday., H." },
                    { label: "Welcome back, and if you don't mind my asking, where were you?",
                      effects: { record_corridors: true, voiceCurious: 1, mysteryDepth: 1, pts: 18 },
                      followup: "The amber lights were sufficient. I will tell you about the rest when you are here. If you would like to hear it., and i would like to tell you." },
                    { label: "Welcome back. Friday it is.",
                      effects: { voiceWarm: 1, pts: 8 },
                      followup: "Until Friday., H." },
                ],
            },
            {
                // V1, high trust, no romance. Composed but with a soft beat:
                // "I am told my preferences are stubborn."
                when: { trustHideo: 'high', hideoRomance: false },
                body: `Tuesday.\n\nApologies for last week. I was unexpectedly away. The peaches can resume this Friday if you can spare them, six, ripe but firm, as always. I am told my preferences are stubborn. I am told this often. It does not deter me.\n\nMy neighbour asked after them. I told her there had been a small interruption. She accepted this without further questions, which is rare for her.\n\nUntil Friday.\n\n- H.`,
                choices: [
                    { label: "Welcome back. Six for Friday. Tell your neighbour we'll pick the best ones.",
                      effects: { voiceWarm: 2, pts: 14 },
                      followup: "I will. She will appreciate it., H." },
                    { label: "Welcome back, and if you don't mind my asking, where were you?",
                      effects: { record_corridors: true, voiceCurious: 1, mysteryDepth: 1, pts: 15 },
                      followup: "The amber lights were sufficient. I will tell you about the rest when you are here. If you would like to hear it." },
                    { label: "Welcome back. Friday it is.",
                      effects: { voiceWarm: 1, pts: 6 },
                      followup: "Thank you., H." },
                ],
            },
            {
                // V3, low trust. Terse.
                when: { trustHideo: 'low' },
                body: `Tuesday. The peaches can resume Friday. Six.\n\nHideo Mossfoot`,
                choices: [
                    { label: "Confirmed. Six for Friday.",
                      effects: { voiceProfessional: 1, pts: 4 },
                      followup: "Hideo Mossfoot" },
                ],
            },
        ],
        // Default body (mid trust + prior emails answered).
        choices: [
            { label: "Confirmed. Glad you're back.",
              effects: { voiceWarm: 1, pts: 8 },
              followup: "Thank you., Hideo" },
            { label: "Confirmed, and if you're comfortable saying, where were you?",
              // v2 §15, record_corridors: the player asked the direct question.
              effects: { record_corridors: true, mysteryDepth: 1, pts: 12 },
              followup: "One of the long corridors. The amber lights were sufficient. Nothing more to say., H." },
        ],
    },
    // Writing spec v6 §05, d09 Petra. Hideo is back. Load-bearing romance beat.
    // Variants ordered most-specific first per kmResolveVariant first-match-wins.
    {
        id: 'd09_petra_relief',
        day: 9, unlock: { type:'date', day:9 },
        from: '🍵 Petra Voss',
        email: 'petra.v@personal.madriguera',
        subject: 'he\'s back',
        portraitEmoji: '🍵',
        portraitColor: '#e8f5e9',
        // Default body (mid or low trust, no romance).
        body: `Hideo's back. I heard from the bakery this morning. I won't pretend I wasn't quietly worried, so. There it is.\n\nThank you for keeping an ear out when I asked. I appreciate it.\n\nThursday's tomorrow. I'll bring my own tin this time, Clow's blend ran out and the dignified thing is to admit defeat. Don't take it personally.\n\n- P.`,
        variants: [
            {
                // V1, high trust + romance: the load-bearing beat. She drops the
                // teasing pretense. Sign-off goes back to "- Petra" (full name);
                // omission-as-intimacy is Hideo's; for Petra it would read as withdrawal.
                when: { trustPetra: 'high', petraRomance: true },
                body: `Hideo's back. He's fine. The bakery owner told me this morning and I almost cried into my tea which would have been undignified.\n\nAnyway. Thursday tomorrow. I'm bringing the blend AND something else for you, don't ask, you'll see. Wear something nice. By which I mean wear whatever, you'll look fine, I've been thinking about it all week.\n\nI'm done pretending I haven't.\n\nSee you tomorrow.\n\n- Petra`,
                choices: [
                    { label: "I've been thinking about it too. Wear what you want. I'll be at the counter.",
                      effects: { voiceWarm: 2, pts: 16 },
                      followup: "Oh thank god. Tomorrow., Petra" },
                    { label: "I'm not letting you off the hook on what you're bringing. See you tomorrow.",
                      effects: { voiceWarm: 1, voiceCurious: 1, pts: 14 },
                      followup: "Good. You shouldn't., P." },
                ],
            },
            {
                // V2, high trust, no romance.
                when: { trustPetra: 'high' },
                body: `Hideo's back. The bakery told me this morning. I'm relieved.\n\nThank you for watching. That meant something.\n\nThursday tomorrow. Bringing my own tea, since Clow's tin betrayed us both. See you then.\n\n- P.`,
                choices: [
                    { label: "Glad to hear it. See you Thursday.",
                      effects: { voiceWarm: 1, pts: 10 },
                      followup: "See you., P." },
                    { label: "Bring something good or don't bother coming.",
                      effects: { voiceWarm: 1, voiceCurious: 1, pts: 12 },
                      followup: "Rude. Acceptable., P." },
                ],
            },
            {
                // V3, silence: d05 was unanswered. Keeps the original terse line.
                when: { unanswered: 'd05_petra' },
                body: `He's back.\n\n- Petra`,
                choices: [
                    { label: "Acknowledge with a small thanks.",
                      effects: { pts: 3 } },
                ],
            },
        ],
        // Default body choices (mid or low trust).
        choices: [
            { label: "Glad to hear it. See you Thursday.",
              effects: { voiceWarm: 1, pts: 8 },
              followup: "See you., P." },
            { label: "Glad he's back. Bring backup tea, I'll pay you in real money this time.",
              effects: { voiceWarm: 1, voiceCurious: 1, pts: 10 },
              followup: "Noted. The going rate is one decent conversation., P." },
        ],
    },
    {
        id: 'd09_clow_checkin3',
        day: 9, unlock: { type:'date', day:9 },
        from: '✦ Clowri · Dokomi Day 9',
        email: 'clowri@madriguera.bun',
        subject: 'two more days ✦',
        portraitEmoji: '✦',
        portraitColor: '#e9d5ff',
        requiresReply: true,
        silenceFrom: 'clow',
        // Default body, writing spec §03 d09, no dominant voice.
        body: `hi ✦\n\ntwo more days and the doors open. i kind of can't believe it.\n\nthe booth looks real now. shelves up, sign hung, products arranged. the limited print from the panel is framed on the back wall. i'll send a photo when i'm not too tired to find the button.\n\nis everything alright with the inventory? and i mean. actually alright. you'd tell me, right ✦\n\n✦`,
        // Resolution order: silence > staff-worry > secret-ending gate > warm > professional > clipped > default.
        // Operational signals (staff, records) outrank performed tone.
        variants: [
            {
                // V1, silence escalates (d02 unanswered).
                when: { unanswered: 'd02_clow_checkin1' },
                body: `hi ✦\n\ntwo days. the doors open friday.\n\ni'm just writing because i'd rather have written and you not need to reply than not written and wished i had. you don't have to send anything back. i'll see you on the 29th if you want to come.\n\nthe booth is ready. the konbini, i hope, is too.\n\n✦`,
                choices: [
                    { label: "I'm here. I'm sorry. It's been a lot. Everything's fine ✦",
                      effects: { voiceWarm: 2, pts: 10 } },
                    { label: "Thank you for writing anyway. Some unusual things this week. I'll tell you at the booth.",
                      effects: { clowAwareness: 1, voiceProfessional: 1, pts: 10 } },
                    { label: "I'll be there friday.",
                      effects: { voiceClipped: 1, pts: 3 } },
                ],
            },
            {
                // V1b, d02 answered but d06 missed. Same softer body.
                when: { unanswered: 'd06_clow_checkin2' },
                body: `hi ✦\n\ntwo days. the doors open friday.\n\ni'm just writing because i'd rather have written and you not need to reply than not written and wished i had. you don't have to send anything back. i'll see you on the 29th if you want to come.\n\nthe booth is ready. the konbini, i hope, is too.\n\n✦`,
                choices: [
                    { label: "I'm here. I'm sorry. It's been a lot. Everything's fine ✦",
                      effects: { voiceWarm: 2, pts: 10 } },
                    { label: "Thank you for writing anyway. Some unusual things this week. I'll tell you at the booth.",
                      effects: { clowAwareness: 1, voiceProfessional: 1, pts: 10 } },
                    { label: "I'll be there friday.",
                      effects: { voiceClipped: 1, pts: 3 } },
                ],
            },
            {
                // V1.5, staff-worry (v2 §13). Staff have been escalating to Clow
                // AND the shop is below 60. No reply choice fixes this, too late
                // for words. Tone-only impact on the d11 finale.
                when: { staffConcern: { gte: 3 }, shopHealth: { lt: 60 } },
                body: `hi ✦\n\ntwo days.\n\ni've been getting some reports. coneja, lib. you don't have to explain over email if you don't want to. just be there friday so we can fix what's left.\n\n✦`,
                choices: [
                    { label: "I'll be there. I'm sorry. I'll explain in person.",
                      effects: { voiceWarm: 1, clowAwareness: 1, pts: 8 },
                      followup: "okay. ✦ thank you. drive safe if you're driving." },
                    { label: "I'll be there. I tried.",
                      effects: { voiceProfessional: 1, pts: 6 },
                      followup: "okay. ✦" },
                    { label: "I'll be there friday.",
                      // No same-day reply, Clow has gone quiet.
                      effects: { voiceClipped: 1, pts: 3 } },
                ],
            },
            {
                // V3, secret-ending gate (v2 §15 + §17). Updated predicate:
                // four prior records + healthy shop. The detective work earned
                // this conversation; doing it on a dying shop did NOT.
                when: { recordsKept: { gte: 4 }, shopHealth: { gte: 60 } },
                body: `hi ✦\n\ntwo days.\n\ni think you've figured out more than i was planning to say in writing. that's okay. i'm glad you've been paying attention.\n\nhow much did you figure out ✦\n\n✦`,
                choices: [
                    { label: "E. Morrow. The night shift. The long corridors. Amber lights. The package that found us on saturday. That's what i figured out.",
                      // Locks the documented ending. clowAwareness/voiceCurious are
                      // tone-only here, they don't affect ending priority (Shop
                      // Health + records do).
                      effects: { clowAwareness: 2, voiceCurious: 2, documentedPath: true, pts: 20 },
                      followup: "oh. okay. you got it. all of it ✦ ten years and you're the first person who said it back to me. i can't say it. i haven't been able to since. so. yes ✦ thank you for seeing it." },
                    { label: "Some of it. I kept notes. I'll bring them friday.",
                      effects: { clowAwareness: 1, voiceCurious: 1, pts: 14 },
                      followup: "okay. that means a lot. i'm so glad you were paying attention ✦" },
                    { label: "More than I'd want to put in writing. Friday.",
                      effects: { clowAwareness: 1, voiceProfessional: 1, pts: 10 },
                      followup: "friday. okay ✦" },
                ],
            },
            {
                // V2, warm-dominant (voiceWarm >= 3).
                when: { voiceWarm: { gte: 3 } },
                body: `hi ✦\n\ntwo days. the doors open friday.\n\nthe booth is ready. honestly i can't believe it. i'll send you a photo if i remember to before i collapse.\n\ni kept meaning to ask you something all week and then losing the nerve so here it is. is everything alright with the inventory? actually alright. you've been so good about everything that i'd believe you if you said yes. but i also want to be the kind of boss who asks. so. ✦\n\n✦`,
                choices: [
                    { label: "Yes everything's alright. You've built something good. Just go drink water and sleep please ✦",
                      effects: { voiceWarm: 2, pts: 10 },
                      followup: "i will. you've been an absolute gift. ✦✦✦" },
                    { label: "Actually yes there have been some things. Nothing burning down. I'll bring my notes to the booth.",
                      // v2 §15: "I'll bring my notes" is a promise, not a recorded
                      // investigation. Records require specific cross-character work.
                      effects: { clowAwareness: 1, voiceCurious: 1, pts: 14 },
                      followup: "good. that means a lot ✦" },
                    { label: "Some unusual things. I kept records. I'll tell you in person.",
                      effects: { clowAwareness: 1, voiceProfessional: 1, pts: 12 } },
                    { label: "All good ✦",
                      effects: { voiceWarm: 1, pts: 6 } },
                ],
            },
            {
                // V4, professional-dominant (voiceProfessional >= 3).
                when: { voiceProfessional: { gte: 3 } },
                body: `hi ✦\n\ntwo days until opening. final status check.\n\nthe booth is ready. all systems normal on this end.\n\nplease give me a final status of the shop. anything outstanding, anything pending, any items you've logged that need handover before friday. i appreciate the way you've been running this.\n\n✦`,
                choices: [
                    { label: "Final status: shop closed nightly at 22:00. Hideo's standing order resumed tuesday. Inspector cleared on day 10. Inventory matches manifest. One item for handover: package found day 6, logged per choice. Notes attached.",
                      // v2 §15, comprehensive status report is tone, not records.
                      effects: { clowAwareness: 2, voiceProfessional: 2, pts: 18 },
                      followup: "acknowledged with thanks. comprehensive and helpful. see you 09:00 the 29th ✦" },
                    { label: "All systems normal. One item for in-person handover.",
                      effects: { voiceProfessional: 1, pts: 6 } },
                    { label: "Acknowledged. See you friday.",
                      effects: { voiceProfessional: 1, voiceClipped: 1, pts: 4 } },
                ],
            },
            {
                // V5, clipped-dominant (voiceClipped >= 3). Recovery option C breaks the pattern.
                when: { voiceClipped: { gte: 3 } },
                body: `hi ✦\n\ntwo days. the doors open friday.\n\nsee you there if you can make it.\n\n✦`,
                choices: [
                    { label: "See you friday.",
                      effects: { voiceClipped: 1, pts: 2 } },
                    { label: "Yeah.",
                      // Spec: escalated (+2).
                      effects: { voiceClipped: 2, pts: 1 } },
                    { label: "Actually there were some things. I kept records. I'll bring them friday.",
                      // Recovery: stops further voiceClipped; historical count remains.
                      // v2 §15: "I kept records" as a promise isn't a named record.
                      effects: { clowAwareness: 1, clippedRecovery: true, pts: 12 },
                      followup: "oh. okay. yes. that means a lot. i'm so glad to hear from you ✦" },
                ],
            },
        ],
        // Default body choices.
        choices: [
            { label: "Everything's in order. See you at the booth ✦",
              effects: { voiceWarm: 1, pts: 8 } },
            { label: "There were some things. I think it's okay. I'll tell you in person.",
              effects: { clowAwareness: 1, voiceProfessional: 1, pts: 10 },
              followup: "okay. yeah. friday it is. ✦" },
            { label: "I kept records. I have notes. I'll bring them.",
              // v2 §15, performing "kept records" doesn't earn a named record.
              effects: { clowAwareness: 1, voiceCurious: 1, pts: 14 },
              followup: "okay. that means a lot ✦ thank you for paying attention." },
            { label: "All in order.",
              effects: { voiceClipped: 1, pts: 3 } },
        ],
    },
    {
        id: 'd09_unknown_corridor',
        day: 9, unlock: { type:'date', day:9, requires: { recordsKept: { gte: 4 } } },
        from: '? [unknown sender]',
        email: '[no return path]',
        subject: '[no subject]',
        portraitEmoji: '⛓',
        portraitColor: '#1a0a10',
        body: `Corridor B-9-amber, sub-level 3.\n\n- - -\n[Return address doesn't bounce. It just goes nowhere. No reply options. It's there. That is the point.]`,
        choices: [],
    },
    // Goro silence, final escalation (§3 "After 2 unanswered emails"). Arrival applies −8 Shop Health.
    // Requires BOTH d05 and d07 unanswered.
    {
        id: 'd09_goro_ultimatum',
        day: 9, unlock: { type:'date', day:9, requires: { unanswered: ['d05_goro', 'd07_goro_crackers'] } },
        from: '🧓 G. Tanaka',
        email: 'g.tanaka@personal.madriguera',
        subject: '-',
        portraitEmoji: '🧓',
        portraitColor: '#f5f5f4',
        requiresReply: true,
        silenceFrom: 'goro',
        arrivalEffect: { shopHealth: -8 },
        arrivalToast: '🧓 Goro hasn\'t come in. Shop Health −8.',
        missedPenalty: { shopHealth: -3 },
        body: `I am a long-standing customer.\n\nPlease restock them.\n\n- G. Tanaka`,
        choices: [
            { label: "You are right. The crackers will be on the shelf today, third shelf, paper bag with red string.",
              effects: { shopHealth: 2, pts: 6 },
              followup: "Acknowledged.\n- G." },
        ],
    },
    // Writing spec v7 §03, Goro engaged-path d09. The empty body. Mutually
    // exclusive with d09_goro_ultimatum (silence cascade). The progression
    // d05 (full spec) → d07 ("Crackers.") → d09 (empty) is the entire arc.
    {
        id: 'd09_goro_engaged',
        day: 9,
        unlock: { type: 'date', day: 9, requires: { answered: ['d05_goro', 'd07_goro_engaged'] } },
        from: '🧓 G. Tanaka',
        email: 'g.tanaka@personal.madriguera',
        subject: '-',
        portraitEmoji: '🧓',
        portraitColor: '#f5f5f4',
        requiresReply: true,
        silenceFrom: 'goro',
        missedPenalty: { shopHealth: -3 },
        body: `- G.`,
        choices: [
            { label: "Confirmed.",
              effects: { shopHealth: 2, pts: 12 },
              followup: "Good.\n- G." },
            { label: "- Manager.",
              effects: { shopHealth: 2, pts: 14 },
              followup: "(Two minutes pass.) Excellent.\n- G." },
        ],
    },
    // Inspector silence, final escalation (§3 "After 2 unanswered"). Only if d08 reminder was ignored.
    {
        id: 'd09_inspector_warning',
        day: 9, unlock: { type:'date', day:9, requires: { unanswered: 'd08_inspector_reminder' } },
        from: '📋 Inspector T. Mumblesworth',
        email: 'inspector@krb.gov.bun',
        subject: 'KR-4471, Final Notice Before Inspection',
        portraitEmoji: '📋',
        portraitColor: '#bfdbfe',
        requiresReply: true,
        silenceFrom: 'inspector',
        missedPenalty: { shopHealth: -5, inspectorFailed: true },
        body: `Dear Konbini Clowri Management,\n\nI note we have not received your checklist.\n\nThe inspection will proceed as scheduled tomorrow, Day 10 (May 27). Specific items will be reviewed on site, including the new wall-adjacent signage clearance requirement.\n\nI would prefer not to be finding issues during the visit. There is still time to submit the checklist before end of day, should you wish to.\n\nThis is intended as courtesy, not pressure. It does, however, run out at midnight.\n\nWith regards,\nInspector T. Mumblesworth\nKonbini Regulators Bureau`,
        choices: [
            { label: "Apologies, submitting the checklist now, end of day at the latest.",
              effects: { shopHealth: 3, pts: 10 },
              followup: "Received. Filed. I will see you tomorrow., T.M." },
            { label: "Acknowledged. We will have everything ready on site.",
              effects: { pts: 4 } },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 10 · Wed May 27, All threads close. Last email to Clow.
    // ════════════════════════════════════════════════
    {
        id: 'd10_bianca_confirm',
        day: 10, unlock: { type:'date', day:10 },
        from: '🐰 Bianca Hopsworth · MasBunny',
        email: 'bianca@masbunny.bun',
        subject: 'Re: first order, shelf placement?',
        portraitEmoji: '🐰',
        portraitColor: '#fce7f3',
        body: `Hi,\n\nConfirming the delivery date is set. A question on shelf placement: near warm lighting if possible, please. The daylight-cured items react well to it.\n\nExplanation cards are included with every novelty SKU. I hope they find a good home.\n\nHopefully yours,\nBianca`,
        variants: [
            {
                when: { unanswered: 'd04_bianca' },
                body: `Hi,\n\nI wanted to check in once more. If the timing wasn't right for the trial order, I understand entirely. The door's open if you want to revisit when Clow returns.\n\nHopefully yours,\nBianca`,
            },
        ],
        choices: [
            { label: "Acknowledged, placement near the warm lighting confirmed.",
              effects: { pts: 6 } },
        ],
    },
    {
        id: 'd10_inspector_outcome',
        day: 10, unlock: { type:'date', day:10 },
        from: '📋 Inspector T. Mumblesworth',
        email: 'inspector@krb.gov.bun',
        subject: 'Inspection outcome, Ref: KR-4471',
        portraitEmoji: '📋',
        portraitColor: '#bfdbfe',
        body: `Dear Konbini Clowri Management,\n\nAll criteria met. The premises is in good standing. See you in six months for the next routine cycle.\n\nThank you for your cooperation throughout.\n\nWith regards,\nInspector T. Mumblesworth`,
        // Bible §3 Inspector: a clean pass is a small Shop Health bonus. Conditional
        // pass costs −10. A full fail costs −15. Order matters: fail must be
        // checked first so low-HP-plus-missing-checklist routes to fail, not conditional.
        arrivalEffect: { shopHealth: 5 },
        arrivalToast: '📋 Inspection passed.',
        variants: [
            {
                when: { inspectorFailed: true },
                body: `Dear Konbini Clowri Management,\n\nThe inspection did not pass. Specific items are listed below for your records.\n\n• Pre-inspection checklist: not received.\n• Wall-adjacent signage clearance: non-compliant.\n• Refrigeration logs: incomplete for the past 30 days.\n\nA re-inspection will be scheduled in twelve weeks. This is not a closure order. It is a request to put things in order.\n\nWe look forward to working with you on this.\n\nWith regards,\nInspector T. Mumblesworth`,
                arrivalEffect: { shopHealth: -15 },
                arrivalToast: '📋 Inspection failed. Shop Health −15.',
            },
            {
                when: { answered: 'd04_inspector_checklist', shopHealth: { lte: 50 } },
                body: `Dear Konbini Clowri Management,\n\nThe inspection has been completed. Two items have been flagged as conditional and will be reviewed at the next cycle. Nothing serious. The wall-adjacent signage requires minor adjustment, and one refrigeration log is unsigned. Both are correctable.\n\nWe look forward to working with you on these matters at the routine cycle.\n\nWith regards,\nInspector T. Mumblesworth`,
                arrivalEffect: { shopHealth: -10 },
                arrivalToast: '📋 Conditional pass. Shop Health −10.',
            },
        ],
        choices: [
            { label: "Acknowledge.",
              effects: { pts: 3 } },
        ],
    },
    {
        id: 'd10_endshift',
        day: 10, unlock: { type:'date', day:10 },
        from: '🐇🐰 Coneja + Lib (internal)',
        email: 'staff@konbini-clowri.bun',
        subject: 'end of week 2, joint report',
        portraitEmoji: '🐇',
        portraitColor: '#fce7f3',
        // Reading the joint report bumps mysteryDepth once. Lib + Coneja have
        // both surfaced their evidence; this is the consolidated picture.
        arrivalEffect: { mysteryDepth: 1 },
        // Default body, fires when packagePath is null/unset (player missed d06_coneja_package
        // entirely). Includes a neutral package paragraph acknowledging the absence.
        body: `End of Week 2. Joint report.\n\nLib's week:\nLights flickered four times this week. Tue, Thu, Sat, Sun. Each occurrence longer than the last, between four and eleven seconds. Always aisle 3.\n\nInventory matches the system end-of-week. Nothing missing. Nothing extra.\n\nThe tall customer was here twice more. Did not buy anything. Stood near aisle 3 both times.\n\nFive customers this week asked about products not on the manifest. Three asked about "the drops." Two asked about other items I did not recognize.\n\nBuilding manager has not responded to my notice about the lights.\n\n- Lib\n\n⸻\n\nconeja's week:\n\nok so lib already said the important stuff. tall coat guy is back. lights still doing the thing. customers still asking for drops we apparently never sold.\n\nsome other stuff:\n\nthe woman from week 1, drops lady, cute, knew us, came back tuesday. didn't ask this time. just looked at the empty space on the shelf for a bit and left. didn't buy anything either. that's three customers now who came in and left without buying. not normal for us.\n\nno package update this week, coneja never got an answer on what to do with the one she found saturday. it's still sealed in the back.\n\npetra dropped off her usual on thursday. she didn't say anything weird but she looked at lib for a long second when she came in. lib didn't notice. or didn't say so.\n\nhideo's been quiet since friday but he's hideo so who knows.\n\nnext week is the last week before you're back. tell us if you want anything different.\n\n- c`,
        variants: [
            {
                // Writing spec v5, opened + drops still out = heaviest variant
                // (a week of visible damage). Reply choices wire beat 2 of the
                // recovery arc. MUST come before the plain opened variant;
                // kmResolveVariant is first-match-wins.
                when: { packagePath: 'opened', dropsPulled: false },
                body: `End of Week 2. Joint report.\n\nLib's week:\nLights flickered four times this week. Tue, Thu, Sat, Sun. Each occurrence longer than the last, between four and eleven seconds. Always aisle 3.\n\nInventory matches the system end-of-week. Nothing missing. Nothing extra.\n\nThe tall customer was here twice more. Did not buy anything. Stood near aisle 3 both times.\n\nFive customers this week asked about products not on the manifest. Three asked about "the drops." Two asked about other items I did not recognize.\n\nBuilding manager has not responded to my notice about the lights.\n\n- Lib\n\n⸻\n\nconeja's week:\n\nok so lib already covered the important stuff so i'm doing gossip ✦ jk no ✦ that's clow's thing lol\n\nTHE DROPS. ok so they're moving. like really moving?? i restocked from the back twice this week. i think six people bought them so far?? maybe seven i lost count somewhere. weird because nobody ever asks for those and now everyone wants them. ANYWAY\n\ndrops lady came in tuesday and oh my god she was. ok. she was reaching for the bags?? and then forgetting halfway?? like picking one up, putting it back, picking another, putting it back. she did this for like a full minute. then she just left without buying. didn't say bye. she hasn't been back since which is weird, she was coming in like every two days.\n\ni'm a little worried about her honestly.\n\nALSO drama: schoolteacher guy. you know the one. mineral water guy?? tells me about his cat (mochi)?? he bought a bag of drops on monday and i saw him again thursday and he just stood by the window for a while and then left. he always says hi to me. always. he has said hi to me for a YEAR. and on thursday he walked right past me. like he forgot.\n\nand there was this guy i'd never seen. brand new face. bought THREE bags. paid in exact change which is. specific. and then walked out the back-corridor exit?? like there's two exits and that's not the normal one. that's the one nobody uses. anyway whatever.\n\npetra dropped off her usual on thursday. she didn't say anything weird but she looked at lib for a long second when she came in. lib didn't notice. or pretended not to notice. either way.\n\nhideo's been quiet since friday but he's hideo so ykno.\n\nok that's the week. let me know if you want me to do anything different. ✦ wait shit i did the star again. sorry. lol. anyway.\n\n- c`,
                choices: [
                    { label: "Pull the drops off the shelf. Set them aside with the package. We're done selling them.",
                      effects: { dropsPulled: true, dropsPulledBy: 'player_beat2', voiceCurious: 1, mysteryDepth: 1, pts: 10 },
                      followup: "oh ok?? cool. yeah will pull them after close. should've done that earlier honestly lol anyway done" },
                    { label: "Leave them out. We'll deal with it next week when Clow's back.",
                      effects: { staffConcern: 1, pts: 3 } },
                ],
            },
            {
                // Writing spec v5, opened + drops already pulled (player intervened
                // at beat 1). Lighter body. Damage was contained.
                when: { packagePath: 'opened' },
                body: `End of Week 2. Joint report.\n\nLib's week:\nLights flickered four times this week. Tue, Thu, Sat, Sun. Each occurrence longer than the last, between four and eleven seconds. Always aisle 3.\n\nInventory matches the system end-of-week. Nothing missing. Nothing extra.\n\nThe tall customer was here twice more. Did not buy anything. Stood near aisle 3 both times.\n\nFive customers this week asked about products not on the manifest. Three asked about "the drops." Two asked about other items I did not recognize.\n\nBuilding manager has not responded to my notice about the lights.\n\n- Lib\n\n⸻\n\nconeja's week:\n\nok so lib already covered the important stuff so i'm doing gossip ✦ jk no ✦ that's clow's thing lol\n\ndrops update: pulled them off the shelf sunday like you said. they're in the back with the package. i think a couple people came in looking for them this week and i just shrugged?? was easier than i thought.\n\ndrops lady didn't come in this week btw. weird because she was coming in every two days. anyway probably nothing.\n\npetra dropped off her usual on thursday. she didn't say anything weird but she looked at lib for a long second when she came in. lib didn't notice. or pretended not to notice. either way.\n\nhideo's been quiet since friday but he's hideo so ykno.\n\nok that's the week. let me know if you want me to do anything different. ✦ wait shit i did the star again. sorry. lol. anyway.\n\n- c`,
            },
            {
                // Package documented, and then vanished.
                when: { packagePath: 'documented' },
                body: `End of Week 2. Joint report.\n\nLib's week:\nLights flickered four times this week. Tue, Thu, Sat, Sun. Each occurrence longer than the last, between four and eleven seconds. Always aisle 3.\n\nInventory matches the system end-of-week. Nothing missing. Nothing extra.\n\nThe tall customer was here twice more. Did not buy anything. Stood near aisle 3 both times.\n\nFive customers this week asked about products not on the manifest. Three asked about "the drops." Two asked about other items I did not recognize.\n\nBuilding manager has not responded to my notice about the lights.\n\n- Lib\n\n⸻\n\nconeja's week:\n\nok so lib already said the important stuff. tall coat guy is back. lights still doing the thing. customers still asking for drops we apparently never sold.\n\nsome other stuff:\n\nthe woman from week 1, drops lady, cute, knew us, came back tuesday. didn't ask this time. just looked at the empty space on the shelf for a bit and left. didn't buy anything either. that's three customers now who came in and left without buying. not normal for us.\n\nthe package is gone. i don't mean we moved it. i mean i went to check the documentation photo against where i left it and the space is clean. lib confirms it's not in any storeroom. that's all i'll say about it.\n\npetra dropped off her usual on thursday. she didn't say anything weird but she looked at lib for a long second when she came in. lib didn't notice. or didn't say so.\n\nhideo's been quiet since friday but he's hideo so who knows.\n\nnext week is the last week before you're back. tell us if you want anything different.\n\n- c`,
            },
            {
                // Package left in place, still sealed.
                when: { packagePath: 'left' },
                body: `End of Week 2. Joint report.\n\nLib's week:\nLights flickered four times this week. Tue, Thu, Sat, Sun. Each occurrence longer than the last, between four and eleven seconds. Always aisle 3.\n\nInventory matches the system end-of-week. Nothing missing. Nothing extra.\n\nThe tall customer was here twice more. Did not buy anything. Stood near aisle 3 both times.\n\nFive customers this week asked about products not on the manifest. Three asked about "the drops." Two asked about other items I did not recognize.\n\nBuilding manager has not responded to my notice about the lights.\n\n- Lib\n\n⸻\n\nconeja's week:\n\nok so lib already said the important stuff. tall coat guy is back. lights still doing the thing. customers still asking for drops we apparently never sold.\n\nsome other stuff:\n\nthe woman from week 1, drops lady, cute, knew us, came back tuesday. didn't ask this time. just looked at the empty space on the shelf for a bit and left. didn't buy anything either. that's three customers now who came in and left without buying. not normal for us.\n\nthe package is still in the back where i left it. nobody's touched it. it still smells like nothing. i'd appreciate if you'd handle it when you're back.\n\npetra dropped off her usual on thursday. she didn't say anything weird but she looked at lib for a long second when she came in. lib didn't notice. or didn't say so.\n\nhideo's been quiet since friday but he's hideo so who knows.\n\nnext week is the last week before you're back. tell us if you want anything different.\n\n- c`,
            },
        ],
        choices: [],
    },
    // Writing spec v5, beat 3 of the drops recovery arc. Only unlocks when
    // the player opened the package, didn't pull the drops, and answered the
    // d10_endshift "leave them out" choice. Coneja saves them on her own. The
    // arrival effect routes through kmApplyEffects so dropsPulled + dropsPulledBy
    // are set the moment the email lands. No reply choices, it's a flag, not
    // a decision point.
    {
        id: 'd10_coneja_pulled',
        day: 10,
        unlock: {
            type: 'date',
            day: 10,
            requires: {
                packagePath: 'opened',
                dropsPulled: false,
                answered: 'd10_endshift',
            },
        },
        from: '🐇 Coneja (internal)',
        email: 'coneja@konbini-clowri.bun',
        subject: 'weird thing, pulled the drops',
        portraitEmoji: '🐇',
        portraitColor: '#fce7f3',
        arrivalEffect: { dropsPulled: true, dropsPulledBy: 'coneja' },
        body: `ok um. weird email. i pulled the drops off the shelf?? all of them. like 20 min ago.\n\ni don't know why exactly. drops lady came in earlier. she was doing the reaching-and-forgetting thing again, except this time she didn't even pick one up. just stood there. and then she left.\n\nand after she left i was just looking at the shelf and i. didn't want them out anymore?? it wasn't even a thought. my hands kind of did it before my brain caught up.\n\nthey're in the back with the package. unopened. just moved.\n\ni don't know. it's been a weird week ykno? the new guy with the exact change. the teacher who didn't say hi. it's probably nothing it's probably just me. but like. anyway. flagging.\n\n- c`,
        choices: [],
    },
    {
        id: 'd10_tplink',
        day: 10, unlock: { type:'date', day:10 },
        from: '🔧 T. Plink · TechFixIt Ltd',
        email: 't.plink@techfixit.bun',
        subject: 'POS service follow-up',
        portraitEmoji: '🔧',
        portraitColor: '#e2e8f0',
        body: `Hello,\n\nPOS unit serviced, receipt printer calibrated. About 1.5 hours on site.\n\nThe register has a slight warmth on the left side that isn't electrical, it's been doing that for years, it's fine.\n\nInvoice attached.\n\nRegards,\nT. Plink`,
        choices: [
            { label: "Acknowledge, thanks.",
              effects: { pts: 3 } },
        ],
    },

    // ════════════════════════════════════════════════
    //   DAY 11 · Thu May 28, ENDING. Dokomi opens tomorrow.
    // ════════════════════════════════════════════════
    // Writing spec v6 §06, Petra emails on her way to her Thursday visit.
    // Romance variant lands different. No trust gate, even cold Petra walks in.
    {
        id: 'd11_petra_morning',
        day: 11, unlock: { type:'date', day:11 },
        from: '🍵 Petra Voss',
        email: 'petra.v@personal.madriguera',
        subject: 'on my way',
        portraitEmoji: '🍵',
        portraitColor: '#e8f5e9',
        body: `On my way. Bringing actual tea this time. Clow's tin is empty and the dignified thing is to admit defeat and bring my own.\n\nSee you in an hour.\n\n- P.`,
        variants: [
            {
                // V1, romance variant. Most specific.
                when: { petraRomance: true },
                body: `On my way. Slept badly because I kept thinking about today, which I admit only because I'm too tired to be smug about it.\n\nI'm bringing tea, the thing I mentioned, and absolutely no plan beyond walking through the door.\n\nSee you in twenty minutes.\n\n- P.`,
                choices: [
                    { label: "I'll be at the counter. No plan either. We'll figure it out.",
                      effects: { voiceWarm: 2, pts: 14 },
                      followup: "Perfect. The two of us with no plan, what could possibly happen., P." },
                    { label: "Hurry up.",
                      effects: { voiceWarm: 1, pts: 12 },
                      followup: "Bossy. Fine., P." },
                ],
            },
        ],
        // Default body choices.
        choices: [
            { label: "See you in an hour.",
              effects: { voiceWarm: 1, pts: 6 } },
            { label: "Walk safe.",
              effects: { voiceWarm: 1, pts: 8 } },
        ],
    },
    // Writing spec v7 §04, Goro Day 11 micro-beat. Optional payoff. Fires
    // only on the full engaged path with healthy shop. Single-line body, no
    // reply required (it's a closing statement, not a question). Mirrors
    // Hideo's "good shop" precedent.
    {
        id: 'd11_goro_note',
        day: 11,
        unlock: {
            type: 'date',
            day: 11,
            requires: {
                answered: ['d05_goro', 'd07_goro_engaged', 'd09_goro_engaged'],
                shopHealth: { gte: 60 },
            },
        },
        from: '🧓 G. Tanaka',
        email: 'g.tanaka@personal.madriguera',
        subject: '-',
        portraitEmoji: '🧓',
        portraitColor: '#f5f5f4',
        body: `Good shop.\n\n- G.`,
        choices: [],
    },
    // Writing spec v10 §03, Bernabé closure beat. Engaged-path-only payoff.
    // Fires if the player connected E. Morrow's name with Bernabé on EITHER
    // d03_barnabe (asked for the contact name) or d06_barnabe_followup (shared
    // the name back). The `requires.anyOf` predicate language is evaluated
    // through kmCheckMatch, so each branch can use any `when:` shape.
    {
        id: 'd11_barnabe',
        day: 11,
        unlock: {
            type: 'date',
            day: 11,
            requires: {
                anyOf: [
                    { choice: { id: 'd03_barnabe', idx: 1 } },
                    { choice: { id: 'd06_barnabe_followup', idx: 1 } },
                ],
            },
        },
        from: '🥐 Barnabé Croissant',
        email: 'b.croissant@tinisnack.bun',
        subject: 'A short note before the order arrives',
        portraitEmoji: '🥐',
        portraitColor: '#fef9c3',
        body: `Hello,\n\nThe TiniSnack order arrives Wednesday next week, as agreed. The driver will introduce themselves at the loading door.\n\nI've stopped writing to E. Morrow. It's been a few days now and I think the silence is the answer, if that makes sense. I appreciate you helping me understand. I'm not sure I would have stopped on my own.\n\nHoney-roasted hazelnut wafers in the first crate. Just for you. Consider it a thank you.\n\nWith regards,\nBarnabé Croissant\nMarketing Director, TiniSnack Co.`,
        choices: [
            { label: "Thanks Barnabé. The wafers will be appreciated. Hope the route stays smooth.",
              effects: { shopHealth: 2, pts: 10 },
              followup: "It will. Take care of the shop.\n- B." },
            { label: "Acknowledged with thanks.",
              effects: { pts: 4 } },
        ],
    },
    // Writing spec v11 §01.3, Hiroshi closure beat. Engaged path only:
    // player asked about the pallet pattern on d07. He's filed it and stopped
    // wondering. Single-choice gate (no anyOf needed).
    {
        id: 'd11_hiroshi',
        day: 11,
        unlock: {
            type: 'date',
            day: 11,
            requires: {
                choice: { id: 'd07_hiroshi_pallet', idx: 1 },
            },
        },
        from: '🌿 Hiroshi Takegawa · FreshDaikon',
        email: 'orders@freshdaikon.veg',
        subject: 'Final weekly update before cycle reset',
        portraitEmoji: '🌿',
        portraitColor: '#bbf7d0',
        body: `Good morning,\n\nFinal weekly update before the regular cycle resets. Tunnel 9 disorientation back to normal. Pallets have not been rearranged since.\n\nI have stopped wondering about the pattern. Whatever it was, it is not my warehouse's problem anymore. Thank you for asking what it looked like. Most clients would not have.\n\nWe will continue weekly deliveries on the usual schedule.\n\nRegards,\nHiroshi Takegawa\nAccount Manager, FreshDaikon Industries`,
        choices: [
            { label: "Acknowledged. Thank you for the consistent service.",
              effects: { shopHealth: 2, pts: 8 },
              followup: "It has been a pleasure.\nRegards,\nHiroshi" },
            { label: "Noted.",
              effects: { pts: 3 } },
        ],
    },
    // Writing spec v11 §02.2, Cassian closure beat. Hold-confirmed path only:
    // player picked choice 0 on d05_cassian. He returns on day 11 to buy a soda
    // and writes a small earnest note. Framed receipt energy.
    {
        id: 'd11_cassian',
        day: 11,
        unlock: {
            type: 'date',
            day: 11,
            requires: {
                choice: { id: 'd05_cassian', idx: 0 },
            },
        },
        from: '🧊 Cassian Frost',
        email: 'c.frost@personal.madriguera',
        subject: 'came back today',
        portraitEmoji: '🧊',
        portraitColor: '#cffafe',
        body: `Hello,\n\nI came back today to buy something different. Not the box, just a soda. I thought you might want to know.\n\nI framed the receipt from May 22 and hung it next to my front door. That probably sounds excessive. It is. Two weeks of looking and you held one for me. I will remember this.\n\nIf you ever need a Sector 7 night shift worker for anything reasonable, write to me.\n\nThank you,\nCassian`,
        choices: [
            { label: "Glad you came back. The shop is here.",
              effects: { shopHealth: 2, pts: 10 },
              followup: "Good to know. Take care.\n- Cassian" },
            { label: "Acknowledge with thanks.",
              effects: { pts: 4 } },
        ],
    },
    {
        id: 'd11_clow_ending',
        day: 11, unlock: { type:'date', day:11 },
        from: '✦ Clowri',
        email: 'clowri@madriguera.bun',
        subject: 'tomorrow',
        portraitEmoji: '✦',
        portraitColor: '#e9d5ff',
        ending: true,    // konmail.js renders the resolved ending body + Dokomi CTA
        body: '[ending body resolved from S, see KONMAIL_ENDINGS]',
        choices: [],
    },
];

// ════════════════════════════════════════════════
//   ENDINGS, five variants resolved at the close of Day 9 (writing spec §09).
//   konmail.js writes S.mailEnding once when d09_clow_checkin3 closes, then
//   pickKonmailEnding(S) returns the matching entry on Day 11. Bodies are the
//   d11_finale variant bodies from writing spec §03.
// ════════════════════════════════════════════════

const KONMAIL_ENDINGS = [
    {
        id: 'good',
        name: 'Everything In Order',
        icon: '🏪',
        accent: '#f0faf4',
        body: `hi ✦\n\ni could tell from the messages honestly. some shops just feel like themselves even from far away. you kept it that way. ✦✦✦\n\nthe booth opens tomorrow. i put something aside for you at the table. just ask for it when you get there. the stickers are there too.\n\nsee you on the 29th. i'll be the one who looks like she hasn't slept in five days but is very happy about it ✦\n\n✦`,
        cta: "Real-world CTA: Come to the Clowri Konbini booth at Dokomi on May 29. Ask for what she put aside.",
    },
    {
        id: 'remembers',
        name: 'The Konbini That Remembers',
        icon: '🌀',
        accent: '#fdf9ec',
        body: `hi ✦\n\nah. it has a habit now ✦ that's fine honestly. some habits are good.\n\nthe booth opens tomorrow. come see what i mean. bring the part of you that knows what damp stone and warm copper smells like.\n\ni'll see you on the 29th ✦✦✦\n\n✦`,
        cta: "Real-world CTA: Come to the booth. Something about it will feel familiar if you've been paying attention.",
    },
    {
        id: 'space',
        name: 'The Space Between Shelves',
        icon: '🚪',
        accent: '#fdf4ec',
        body: `hi ✦\n\nit's okay. we'll sort it out together. i left some things behind anyway so it's not all on you ✦\n\nthe booth is open tomorrow. come find me ✦\n\nsee you on the 29th ✦\n\n✦`,
        cta: "Real-world CTA: Come to the booth. Things will be better after.",
    },
    {
        id: 'documented',
        name: 'Documented',
        icon: '📋',
        accent: '#fff0f6',
        body: `how much did you figure out ✦\n\nthe booth opens tomorrow. i'll be there.\n\nthere's something i can hand you in person. i still have the photo from when we opened. i look so young. you'll see what i mean ✦\n\n✦`,
        cta: "Real-world CTA: Come to the booth on May 29. She has something to hand you.",
    },
    {
        id: 'closed',
        name: 'Temporarily Closed',
        icon: '🔦',
        accent: '#f5eef0',
        body: `hi ✦\n\nthe lights are still on. that matters ✦\n\nwe'll fix the rest together. the booth opens tomorrow. come find me, i'll be there.\n\nalso something is in the back corridor. yeah i know. we'll deal with it.\n\nsee you on the 29th. i love you ✦\n\n✦`,
        // Appended (writing spec §03 late-joiner addendum) when first_login_day >= 7.
        lateJoinerAddendum: `\n\ni don't know exactly when you started. but i'm glad you did ✦`,
        cta: "Real-world CTA: Come to the booth. She still wants you there. So do we.",
    },
];

const _KONMAIL_ENDING_BY_ID = Object.fromEntries(KONMAIL_ENDINGS.map(e => [e.id, e]));

// Reads the ending locked at d09 close (S.mailEnding). Falls back to the
// closed ending if Day 11 was reached without d09 ever closing (shouldn't
// happen via the calendar engine, but defensive).
function pickKonmailEnding(S) {
    const id = S && S.mailEnding;
    return _KONMAIL_ENDING_BY_ID[id] || _KONMAIL_ENDING_BY_ID.closed;
}

// ── Exports ──
window.KONMAIL_STORY        = KONMAIL_STORY;
window.KONMAIL_STORY_DAYS   = KONMAIL_STORY_DAYS;
window.KONMAIL_STORY_START  = KONMAIL_STORY_START;
window.KONMAIL_STORY_END    = KONMAIL_STORY_END;
window.KONMAIL_ENDINGS      = KONMAIL_ENDINGS;
window.pickKonmailEnding    = pickKonmailEnding;
